// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import addressValidationFactory from '../common/AddressValidation.js';
import { handleDisplayFor, setElementsFromScope, setDisabled, setOptionsForSelect } from "../../utilities/selectorHelpers";
import { createPreventDefault, isPresent, formatPhone } from '../../utilities/general';
import { instantiateSelect2 } from "../../utilities/select2able";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import EditChecker from '../../components/EditChecker/EditChecker';
import { setSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery';
import { isNull, isNullOrUndefined } from 'util';
// Additional Imports...

const facilityWrapperTemplate = require('./html/createOrganization/vmoFormFacilityFormWrapper.html');
const facilityTypeHtml = require('./html/createOrganization/vmoFacilityType.html');
const inboundClassificationHtml = require('./html/createOrganization/vmoInboundClassification.html');
const facilityDetailsHtml = require('./html/createOrganization/vmoFacilityDetails.html');
const facilityAddressHtml = require('./html/createOrganization/vmoFacilityAddress.html');
const facilityContactHtml = require('./html/createOrganization/vmoFacilityContact.html');
const sharedModalHtml = require("../../sharedHtml/modal.html");
const selectOrgModalBodyHtml = require('./html/createOrganization/selectFromOrgsModalBody.html');

const searchCarrierByScacWrapperTemplate = require('./html/createOrganization/carrierByScacDetails.html');
const carrierTeamMemberDetailsWrapperTemplate = require('./html/createOrganization/carrierTeamMemberDetails.html');
const addCarrierTeamMemberWrapperTemplate = require('./html/createOrganization/addCarrierTeamMember.html');
const addCarrierTeamMemberDetailsWrapperTemplate = require('./html/createOrganization/teamMemberDetails.html');
const validateScacCodeWrapperTemplate = require('./html/createOrganization/validateScacCode.html');
const transportationBrokerSectionWrapperTemplate = require('./html/createOrganization/transportationBrokerSection.html');
const optionTemplateHtml = require('../../sharedHtml/linkGroup/optionTemplate.html');
const createCarrierOrBrokerModalBodyHtml = require('./html/createOrganization/createOrganizationModal.html');
const modalHtml = require("../../sharedHtml/modal.html");
const newCarrierWrapperTemplate = require('./html/createOrganization/createNewCarrierSection.html');

const targetSelector = "#add-organization-form";
let carData = {};
let scacDetails = {};
let teamMemberArray = [];
let valScac = '';
let btnClicked;
run(targetSelector, (mainEl) => {
  attachOrgForm(mainEl);
});

function attachOrgForm(mainEl) {
  let validator;
  let validationOpts = {
    debug: true,
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  };
  let activeFormElement;
  let carrierBrokerModal;
  const modalOpts = { backdrop: 'static', show: false };
  const editForm = mainEl.data("edit-form");
  const portletNamespace = mainEl.data('portlet-namespace');
  let organizations = mainEl.data('organizations');
  let facilityArray = organizations.cmrAddress || [];
  let editFlag = false;
  let organizationId = 0;
  if (editForm) {
    organizationId = organizations.orgId;
  }

  const isHoneyComb = mainEl.data('is-honeycomb');
  const countries = mainEl.data('countries');
  const usaStates = mainEl.data('usa-states');
  const caProvinces = mainEl.data('ca-provinces');
  const phoneCodes = mainEl.data('country-phone-code-list');
  const defaultCountry = mainEl.data('default-country');
  const facilityTypes = mainEl.data('facility-types');
  const inboundClassificationTypes = mainEl.data('inbound-classification-types');
  const retailerFedexAccounts = mainEl.data('retailer-fedex-accounts');
  const retailerCasAccounts = mainEl.data('retailer-cas-accounts');
  const retailerFacilityForRMS = mainEl.data('retailer-facility-for-rms');
  const detailsPageUrl = mainEl.data("details-url");
  const carrierDetailsPageUrl = mainEl.data("carrier-details-url");
  const brokerOrgDetailsUrl = mainEl.data("broker-org-details-url");
  const brokerCreateUrl = mainEl.data("broker-create-url");
  const addressEl = $('#edit-address-verification');
  const validateOrgNameUrl = mainEl.data("validate-org-url");
  const validateCadLocationNameUrl = mainEl.data("validate-cad-location-name-url");
  const validateCadAddressIdUrl = mainEl.data("validate-cad-address-id-url");
  const addressValidationUrl = mainEl.data("address-validation-url");
  const organizationList = mainEl.data("retailer-organization-list");
  const submitURL = mainEl.data("submit-url");
  const carrierSubmitURL = mainEl.data("carriersubmit-url");
  const orgFacilityForm = $('#org-facility-form');
  const cancelBtnUrl = mainEl.data("cancel-url");
  const duplicateCadLocationNameMessage = mainEl.data("duplicate-location-name-message");
  const duplicateAddressIdMessage = mainEl.data("duplicate-address-id-message");

  const duplicateCarrerOrgNameMessage = mainEl.data("duplicate-carrer-org-name-message");
  const duplicateAddressMessage = mainEl.data("duplicate-address-message");
  const checkDuplicateAddressUrl = mainEl.data("validate-duplicate-address-url");
  const retailerOrgtype = mainEl.data('retailer-orgtype');
  const getScacDetailsUrl = mainEl.data('scac-details-url');
  const searchByScacUrl = mainEl.data('search-by-scac-url');
  const carrierSectionHtml = $('#carrier-section-div');
  const addCarrierTeamMemberDivSec = $('#addCarrierTeamMemberDivSec');
  const carrierListByMerchant = mainEl.data('carrier-by-merchant-list');
  const continueCarrierOrgType = mainEl.data('continue-carrier-orgtype-url');
  const continueBrokerOrgType = mainEl.data('continue-broker-orgtype-url');
  const checkUserNameValidation = mainEl.data('check-user-name-url');
  const affiliatedCarrierOrgs = mainEl.data("affiliated-carrier-orgs");
  const teamMemberDetailsForEdit = mainEl.data("teammember-details");
  const checkSCACExistsForCarrierUrl = mainEl.data('check-scac-exists-for-carrier-url');
  const checkSCACExistsForRetailerUrl = mainEl.data('check-scac-exists-for-retailer-url');
  const cmrCarrier = mainEl.data("cmr-carrier");
  let createButton = $('.create-carrier-btn').text();
  let useFoundButton = $('.use-found-carrier-btn').text();
  let cmrCarrierScacList = mainEl.data('carrier-scac-list');
  let validationReqdCountries = mainEl.data("validation-reqd-countries");
  let orgName = "";
  let orgId = "";
  let addValResponse = {};
  let btnClickedEdit;
  let selectFromOrgModal;
  let continueModal;
  let orgNameDuplicateModal;
  let elsPage = {};
  let elsModal = {};
  let oldCadId;
  let oldCadStatus;
  let isOrgDuplicate = false;
  let isAddressDuplicate = false;
  let isUseFoundCarrierFlow = false;
  let saveBtnClicked = false;
  let saveTeamMemberModel;

  const elsMap = {
    addFacilitySection: ".add-facility-section",
    organizationName: "#org-address-name",
    addFirstFacilityBtn: ".first-add-facility-btn",
    saveVendorOrgAddressBtn: ".save-vendor-org-address-btn",
    masterFormCancelBtn: ".master-facility-cancel-section-btn",
    facilityEditSectionBtn: ".facility-edit-section-btn",
    facilityUpdateSectionBtn: ".facility-update-section-btn",
    facilityCancelSectionBtn: ".facility-cancel-section-btn",
    masterFormSectionParent: ".master-form-section",
    customExpanderParent: ".custom-expander-parent",
    customExpanderTarget: ".custom-expander-target",
    nextAddfacilityBtn: ".next-add-facility-btn",
    facilityFormDiv: ".facility-information-container",
    selectOrgPopupBtn: "#selectOrg",
    inboundClassification: ".inboundClassification",
    facilityType: ".rms-facility-type",
    cancelMainFormBtn: ".cancel-mainform-btn",
    orgType: "#orgType",
    config: "#config",
    orgNameSection: "#orgNameSection",
    orgAddressname: "#orgAddressname",
    carrierSection: ".carrier-section",
    brokerSection: "#broker-section",
    searchCarrier: ".search-carrier",
    carrierScacTypeAhead: "#find-by-carrier-scac",
    carrierDetailsDiv: ".carrier-info-div",
    facilityNwSection: "#facility-nw-section",
    useFoundCarrierBtn: ".use-found-carrier-btn",

    carrierContactInfo: ".carrier-contact-info",
    teamCarrierSection: ".team-carrier-section",
    teamMemberDetails: "#team-member-details",
    teamMemberBtn: ".team-member-btn",

    organizationType: "organization-type",
    organizationForm: '#organization-form',
    transportationBrokerSection: ".transportation-broker-section",
    organizationCarrierForm: '#organization-carrier-form',

    scacCode: '.scac-code',
    cancelTeamMemberBtn: '.cancel-team-member-btn',
    saveTeamMemberBtn: '.save-team-member-btn',
    organizationCarrierForm: '#organization-carrier-form',
    createCarrierBtn: '.create-carrier-btn',
    teamMemberSectionDetails: '.team-member-section-details',
    carrierListForBroker: '#find-carriers-for-broker'
  };

  const elsModalMap = {
    orgnSelectBtn: '.organization-select-btn',
    dropDownOption: "#organizationDropdown",
    abandonFormBtn: "#abandon-form-btn",
    saveTeamMemberDialogBtn: ".save-team-member-dialog-btn",
    carrierContinueBtn: '.continue-btn'
  };

  const carrierElementsMap = {
    carrierScacCode: "#carrierScacCode",
    carrierName: "#carrierName",
    carrierGln: "#carrierGln",
    carrierContactName: "#carrierContactName",
    carrierContactEmail: "#carrierContactEmail",
    carrierContactPhone: "#carrierContactPhone",
    carrierAddLine1: "#carrierAddLine1",
    carrierAddLine2: "#carrierAddLine2",
    carrierCountry: "#carrierCountry",
    carrierInfoButton: ".carrier-info-button"
  };

  const addressElementsMap = {
    submitThisAddressBtn: '#submit-edit-returned-address',
    addressEntered: '#div-address-enetered',
    enteredAddressRadio: '#radio-use-entered-address',
    enteredAddressText: '#edit-ret-address-entered',
    addressReturned: '#div-address-returned',
    returnedAddressRadio: '#radio-returned-address',
    returnedAddressText: '#edit-ret-address-returned',
    invalidAddress: '#div-address-returned-empty',
    invalidAddressText: '#edit-ret-address-returned-not-found',
    modifyAddressBtn: '#modify-edit-returned-address'

  };

  const carrierTeamMemberElementsMap = {
    carTeamMemberUsername: "car-team-member-username",
    manageTeamMemberUserName: ".username-team",
    manageTeamMemberUserEmail: ".email-team"
  };

  function init() {
    setValidator();
    setElements();
    getRenderedOrgType();
    hideAllExpandableSectionsOnPageLoad();
    generateModals();
    buildModalHtml();
    setElementsOnModal();
    bindElements();
    createStaticForm();
    if (elsPage.orgType.val() == "Facility Network") {
      populateEdit();
    }
    setupEditChecker();
    setInitialState();
    if (elsPage.orgType.val() == "Carrier") {
      validateScacCode();
    }
    $('.vmoFacilityType').click(function () {
      $(".errorMsgForFacilityTypeCheckbox").hide();
    });
    handleSwitchingBrokerStateInput();
  }

  function setInitialState() {
    instantiateScacTypeAhead();
    const scacIdLookup = elsPage.carrierScacTypeAhead;
    scacIdLookup.on("select2:select", function () {
      let scacId = scacIdLookup.select2('data')[0].id;

      $.ajax({
        async: false,
        data: {
          scacId: scacId
        },
        url: getScacDetailsUrl,
        dataType: "JSON",
        type: 'POST',
        success: function (data) {
          displayCarrierDetails(data);
          carData = data;
        }
      });

    });

  }
  function displayCarrierDetails(data) {
    let countryName = "";
    elsPage.carrierDetailsDiv.removeClass('hidden');
    elsPage.carrierInfoButton.removeClass('hidden');
    elsPage.createCarrierBtn.removeAttr('disabled');
    elsPage.useFoundCarrierBtn.removeAttr('disabled');
    elsPage.carrierName.text(data[0].carName);
    elsPage.carrierScacCode.text(data[0].carScac);
    elsPage.carrierGln.text(data[0].carGln);
    elsPage.carrierContactName.text(data[0].carContactName);
    elsPage.carrierContactEmail.text(data[0].cmrAddress.cadContactEmail);
    elsPage.carrierContactPhone.text(data[0].carPhoneCountryCode + " " + data[0].carContactPhone);
    elsPage.carrierAddLine1.text(data[0].cmrAddress.cadAddress1 + ((data[0].cmrAddress.cadAddress2 == null) ? "" : ", " + data[0].cmrAddress.cadAddress2));
    elsPage.carrierAddLine2.text(data[0].cmrAddress.cadCity + ", " + data[0].cmrAddress.cadState + " " + data[0].cmrAddress.cadZipcode);
    if (data[0].cmrAddress.cadCountry == 'US') {
      countryName = "United States of America";
    } else if (data[0].cmrAddress.cadCountry == 'CA') {
      countryName = "Canada";
    } else {
      countryName = data[0].cmrAddress.cadCountry;
    }
    elsPage.carrierCountry.text(countryName);


  }

  function buildModalHtml() {

  }

  function showCarrierOrgModal(e) {
    e.preventDefault();
    carrierBrokerModal.modal('show');

  }

  function instantiateScacTypeAhead() {
    const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      async: false,
      processResults: function (data, params) {
        if ($.isEmptyObject(data)) {
          elsPage.carrierInfoButton.removeClass('hidden');
          elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');
          elsPage.createCarrierBtn.removeAttr('disabled');
        }
        params.page = params.page || 1;
        return {
          results: data,
          pagination: {
            more: (params.page * 20) < data.total_count
          }
        };
      },
      cache: true
    };

    function configureDataCallback({ paramKey }) {
      return function (params) {
        return {
          [paramKey]: params.term
        };
      };
    }

    elsPage.carrierScacTypeAhead.select2({
      placeholder: "Start typing carrier SCAC code",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: elsPage.carrierScacTypeAhead.data('get-scac-list'),
        data: configureDataCallback({ paramKey: 'cmrCarrierByScac' }),
        templateResult: function (result) {
          return result.text;
        }
      },
      minimumInputLength: 2

    });
  }


  //Set the validator for the Main Form with the Organization Name 
  function setValidator() {
    validator = mainEl.find(".organizationForm").validate(validationOpts);
    validator.settings.ignore = ":disabled, :hidden";
    // HB-12744 add jquery custom validation for duplicate broker org name
    $.validator.addMethod("checkDuplicateOrgName", validateOrgName, 'Organization name already exists');

    $(".broker-org-name").rules("add", {
      checkDuplicateOrgName: true
    });

    $.validator.addMethod( //override email with django email validator regex - fringe cases: "user@admin.state.in..us" or "name@website.a"
      'email',
      function (value, element) {
        return this.optional(element) || /(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*|^"([\001-\010\013\014\016-\037!#-\[\]-\177]|\\[\001-\011\013\014\016-\177])*")@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)$)|\[(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}\]$/i.test(value);
      },
      'Please enter a valid email address.'
    );

  }


  function setElements() {
    //Tie the scope of the elements on the page 
    setElementsFromScope(elsPage, elsMap, orgFacilityForm);
    setElementsFromScope(elsPage, addressElementsMap, addressEl);
    setElementsFromScope(elsPage, carrierElementsMap, orgFacilityForm);
    setElementsFromScope(elsPage, carrierTeamMemberElementsMap, orgFacilityForm);
    //HB-12085
    //setElementsFromScope(elsPage,carrierDetailsElementsMap,carrierSectionHtml);
  }

  function setElementsOnModal() {
    const $body = $('body');
    setElementsFromScope(elsModal, elsModalMap, $body);
  }

  function setupEditChecker() {
    EditChecker.bindNavigation();
    EditChecker.bindChangeListener("#add-organization-form");
    EditChecker.bindChangeListener(".child-form-edit");
    EditChecker.bindChangeListener("span.select2");
    //EditChecker.bindCancelButton("#cancel-vendor-org-address-btn");
    EditChecker.bindCancelButton(".cancel-mainform-btn");
  }

  function bindElements() {
    mainEl.find(elsMap.masterFormSectionParent).hide();

    if (editForm) {
      elsPage.organizationName.val(organizations.orgName);
    }

    if (editForm && organizations.orgType == "Transportation Broker") {
      $('.master-form-section').hide();
      elsPage.addFacilitySection.hide();
      elsPage.nextAddfacilityBtn.hide();
      elsPage.selectOrgPopupBtn.hide();
      elsPage.facilityNwSection.hide();
      setTeamMembersForEdit("broker");
      setAffiliatedCarrierOrgsForEdit();
    } else if (editForm && organizations.orgType == "Carrier") {
      editCarrierAndTeamMember();
    } else if (editForm && facilityArray.length) {
      elsPage.addFacilitySection.hide();
      elsPage.nextAddfacilityBtn.show();
      elsPage.selectOrgPopupBtn.show();
      elsPage.facilityNwSection.hide();
    } else {
      //elsPage.addFacilitySection.show();//HB-12202
      elsPage.nextAddfacilityBtn.hide();
      elsPage.selectOrgPopupBtn.hide();
    }
    elsPage.organizationName.on("blur", validateOrgName);
    mainEl.on("blur", "#organization-new-name", validateOrgName);
    //elsPage.carrierSection.find('[name=new-carrier-contact-state]').on('change', validateDuplicateAddress);
    elsPage.addFirstFacilityBtn.click(createPreventDefault(showStaticForm));
    elsPage.modifyAddressBtn.on('click', modifyFacilityAddress);
    elsPage.submitThisAddressBtn.on('click', submitFacilityAddress);
    elsPage.selectOrgPopupBtn.on('click', showOrganizationSelectModal);
    elsModal.orgnSelectBtn.on('click', orgSelectBtnHandler);
    elsModal.abandonFormBtn.on('click', abandonFormHandler);
    elsPage.saveVendorOrgAddressBtn.on('click', orgSaveBtnHandler);
    mainEl.on("click", '.next-add-facility-btn', addFacilityHandler);
    mainEl.on("click", '.facility-edit-section-btn', expandFacilitySectionClickHandler);
    mainEl.on("click", '.facility-update-section-btn', collapseFacilitySectionClickHandler);
    mainEl.on("click", '.master-facility-cancel-section-btn', cancelFormClickHandler);
    mainEl.on("click", '.facility-cancel-section-btn', cancelEditFacilityClickHandler);
    mainEl.on("change", ".facilty-country", handleCountryChange);
    mainEl.on("blur", ".facility-name", isDuplicateCadLocationName);
    mainEl.on("blur", ".facility-id", isDuplicateCadAddressId);
    mainEl.on("click", ".add-facility-cancel-btn", handleCancelAddFacility);
    elsPage.orgType.on('change', orgTypesHandler);
    mainEl.on("click", '.use-found-carrier-btn', addCarrierHandler);
    mainEl.on("click", '.create-carrier-btn', addCarrierHandler);
    mainEl.on("click", '.clear-carrier-btn', clearSearchScacHandler);
    mainEl.on("click", ".team-member-btn", newTeamMemberAddHandler);
    mainEl.on('click', '.save-team-member-btn', saveTeamMemberBtnHandler);
    mainEl.on('change', '.carrier-phone-code-add-carrier-team-member', handleCarrierPhoneCodeTeamMember);
    mainEl.on('click', '.cancel-team-member-btn', cancelTeamMemberBtnHandler);
    mainEl.on('click', '.edit-team-member-btn', editTeamMemberBtn);
    mainEl.on('click', '.remove-team-member-btn', removeTeamMemberBtn);
    //mainEl.on("click",'.trans-broker-create-carrier-btn', onclickCreateCarrier);
    mainEl.on("click", '.trans-broker-create-carrier-btn', showCarrierOrgModal);
    //els.createCarrier.on("click", showCarrierOrgModal);
    elsModal.saveTeamMemberDialogBtn.on('click', loadCarrierDetailsHandler);
    mainEl.on("blur", "#scac-new-code", validateScacCode);
    mainEl.on('click', '.val-use-found-carrier-btn', useCarrierScacCode);
    elsModal.carrierContinueBtn.on('click', handleCarrierBrokerModalClose);
    mainEl.on("blur", ".username-team", checkUserName);
    mainEl.on("change", ".email-team", checkEmailId);
    elsPage.brokerSection.find(".broker-org-country").on("change", handleSwitchingBrokerStateInput);
    //elsPage.brokerSection.find('.broker-phone-number').inputmask({ mask: "(999) 999-9999" });
    $('#carrier-org-edit-url').on('click', editCarrierAndTeamMember);
    elsPage.brokerSection.find(".broker-phone-code").on("change", handleBrokerPhoneValidation);

  }


  function orgTypesHandler() {
    if (elsPage.orgType.val() == 'Facility Network') {
      elsPage.addFacilitySection.show();
      elsPage.facilityNwSection.show();
      elsPage.carrierSection.hide();
      elsPage.transportationBrokerSection.hide();
      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
      elsPage.facilityFormDiv.show();
    } else if (elsPage.orgType.val() == 'Carrier') {
      elsPage.organizationName.val('');
      var closetForm = elsPage.organizationName.closest('form');
      closetForm.validate().resetForm();
      facilityArray = [];
      $('.child-form-edit').empty();
      $('.master-form-section').hide();
      elsPage.facilityFormDiv.hide();
      elsPage.nextAddfacilityBtn.hide();
      elsPage.addFacilitySection.hide();
      elsPage.facilityNwSection.hide();
      elsPage.transportationBrokerSection.hide();
      elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
      showCarrierSection();
      $('.team-broker-section').hide();
      $('.team-carrier-section').show();
    } else if (elsPage.orgType.val() == 'Transportation Broker') {
      elsPage.nextAddfacilityBtn.hide();
      $('.master-form-section').hide();
      elsPage.addFacilitySection.hide();
      elsPage.facilityNwSection.hide();
      elsPage.carrierSection.hide();
      elsPage.transportationBrokerSection.show();
      tranportationBrokerHandler();
      $('.team-broker-section').show();
      $('.team-carrier-section').hide();
      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
    }
  }

  function showCarrierSection() {
    elsPage.carrierSection.show();

  }

  function carrierContinueBtn() {
    handleCarrierBrokerModalClose();
  }

  function handleCarrierBrokerModalClose(e) {
    e.preventDefault();
    carrierBrokerModal.modal("hide");
    window.open(brokerCreateUrl + '&ContinueCarrierOrgType=true', '_blank');
  }

  //Hb-12202
  function getRenderedOrgType() {
    elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
    if (continueCarrierOrgType == '' && continueBrokerOrgType == '') {
      let returnTypeList = "";
      returnTypeList = retailerOrgtype.map((e1) => {
        return render("<option value = '{%-key %}'>{%-value %}</option>", {
          key: e1.cdmMeaning,
          value: e1.cdmMeaning
        });
      });
      elsPage.orgType.append(returnTypeList.join(''));
    } else if (continueCarrierOrgType != '' && continueBrokerOrgType == '') {
      elsPage.orgType.append("<option value ='Carrier'>Carrier</option>");
      elsPage.orgType.val('Carrier');
      elsPage.orgType.trigger('change.select2');
      orgTypesHandler();
    } else if (continueCarrierOrgType == '' && continueBrokerOrgType != '') {
      elsPage.orgType.append("<option value ='Transportation Broker'>Transportation Broker</option>");
      elsPage.orgType.val('Transportation Broker');
      elsPage.orgType.trigger('change.select2');
      orgTypesHandler();
    }
    if (editForm) {
      elsPage.orgType.val(organizations.orgType);
      elsPage.orgType.attr('disabled', 'disabled');
      elsPage.config.hide();
      elsPage.orgNameSection.show();
      elsPage.orgAddressname.val(organizations.orgName);
      orgTypesHandler();
    }
  }
  function handleCancelAddFacility() {
    if (editForm) {
      editFlag = false;
      elsPage.nextAddfacilityBtn.show();
    }

    if (!facilityArray.length) {
      elsPage.addFacilitySection.show();
      elsPage.nextAddfacilityBtn.hide();
      elsPage.facilityNwSection.show();
    } else {
      elsPage.addFacilitySection.hide();
      elsPage.nextAddfacilityBtn.show();
      elsPage.facilityNwSection.hide();
    }

    hideAllExpandableSectionsOnPageLoad();
    resetMasterForm();
  }

  function abandonFormHandler(e) {
    e.preventDefault();
    editFlag = false;
    hideAllExpandableSectionsOnPageLoad();
    hideAbandonFormModal();
    expandFacilitySection(btnClickedEdit);
  }

  function orgSaveBtnHandler(e) {
    const isMainFormValid = mainEl.find(".organizationForm").valid();
    if (elsPage.saveVendorOrgAddressBtn.hasClass("disabled")) {
      e.preventDefault();
    }
    else {
      const orgFormEle = mainEl.find("#master-form");
      if (isOrgDuplicate && elsPage.orgType.val() == 'Facility Network') {
        showOrgNameDuplicateModal();
      }
      else {
        if (orgFormEle.is(':visible')) {
          const isValidOrgForm = validateForm(orgFormEle);
          if (isValidOrgForm && !isOrgDuplicate && checkFacilityTypesHC(orgFormEle) && isMainFormValid) {
            saveBtnClicked = true;
            validateAddressModal(orgFormEle);
          }
        }
        else if (isMainFormValid) {
          if (elsPage.orgType.val() == 'Carrier') {
            saveBtnClicked = true;
            if(btnClicked === 'create' && !isUseFoundCarrierFlow){
              validateDuplicateAddress();
            if (isAddressDuplicate == true) {
              return;
            }
          }
            validateCarrierAddress();
          } else {
            saveModalHandler();
          }
        }
      }
    }
  }

  function validateCarrierAddress() {
   
    const orgFormEle = mainEl.find("#master-form");
    setElementsFromScope(elsPage, {}, orgFormEle);
    var carrierAddr = {};
    let carrierContactCountry = '';
    let carrierContactAddress1 = '';
    let carrierContactAddress2 = '';
    let carrierContactCity = '';
    let carrierContactState = '';
    let carrierContactPostalcode = '';
    if (btnClicked === 'create') {
      carrierContactCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
      carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
      carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
      carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
      carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();
      carrierContactPostalcode = elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val();
    } else if (btnClicked === 'found') {
      carrierContactCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
      carrierContactAddress1 = elsPage.carrierSection.find('[name=carrier-contact-address1]').val();
      carrierContactAddress2 = elsPage.carrierSection.find('[name=carrier-contact-address2]').val();
      carrierContactCity = elsPage.carrierSection.find('[name=carrier-contact-city]').val();
      carrierContactState = elsPage.carrierSection.find('[name=carrier-contact-state]').val();
      carrierContactPostalcode = elsPage.carrierSection.find('[name=carrier-contact-postalcode]').val();
    }
    else {
      carrierContactCountry = $("#org-facility-form").find('[name=carrier-contact-country]').val();
      carrierContactAddress1 = $("#org-facility-form").find('[name=carrier-contact-address1]').val();
      carrierContactAddress2 = $("#org-facility-form").find('[name=carrier-contact-address2]').val();
      carrierContactCity = $("#org-facility-form").find('[name=carrier-contact-city]').val();
      carrierContactState = $("#org-facility-form").find('[name=carrier-contact-state]').val();
      carrierContactPostalcode = $("#org-facility-form").find('[name=carrier-contact-postalcode]').val();
    }
    carrierAddr.cadAddress1 = carrierContactAddress1;
    carrierAddr.cadAddress2 = carrierContactAddress2;
    carrierAddr.cadCity = carrierContactCity;
    carrierAddr.cadState = carrierContactState;
    carrierAddr.cadZipcode = carrierContactPostalcode;
    carrierAddr.cadCountry = carrierContactCountry;
    
    let validateAddressForCountry=false;
      $(validationReqdCountries).each(function() {
     if(this.cdmMeaning.toString() === carrierAddr.cadCountry||this.cdmValue.toString() === carrierAddr.cadCountry) {
       validateAddressForCountry = true;
       return false;
     } 
     });

     
    if(validateAddressForCountry){
        $.ajax({
          url: addressValidationUrl,
          type: "POST",
          data: carrierAddr,
          beforeSend: function () {
            $.blockUI({ message: 'Validating Address, Please Wait..' });
          },
          complete: function () {
            $.unblockUI();
          },
          success: function (data, textStatus, jqXHR) {
            addValResponse = $.parseJSON(data);
            if (addValResponse.result == true) {
              EditChecker.setPageClean();
              elsPage.addressReturned.css("display", "");
              elsPage.invalidAddress.css("display", "none");
              elsPage.invalidAddressText.css("display", "none");
              elsPage.returnedAddressRadio.prop('checked', false);
              elsPage.enteredAddressRadio.prop('checked', true);
              elsPage.returnedAddressRadio.show();
              checkSubmitAddressForm(addValResponse);
            } else {
              elsPage.addressReturned.css("display", "none");
              elsPage.invalidAddress.css("display", "");
              elsPage.invalidAddressText.css("display", "");
              elsPage.invalidAddressText.html('Unable to find a validated address');
              elsPage.returnedAddressRadio.hide();
              elsPage.returnedAddressRadio.prop('checked', false);
              elsPage.enteredAddressRadio.prop('checked', true);
              checkSubmitAddressForm(addValResponse);
            }
          }
        });
    }else{
      submitFacilityAddress();
    }
  }

  function saveCarrierModalHandler(cmrCarrierAddressObj) {

    if (!isOrgDuplicate) {
      const teamMembersObjForSubmit = prepareTeamMemberForSubmit("carrier");
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Save Carrier Organization",
        confirmModalBody: '<div class="q-pad-all-xl">Once saved this carrier organization can be assigned to your ASNs and scheduled warehouse dock appointments. Carrier team members, if applicable, will also be able to sign in to view and edit scheduled appointments that are assigned to this carrier.</div>',
        confirmModalBtnText: "Save",
        onConfirmClick: function (cmrCarrierAddressObj) {

          let orgName = '';
          let scacCode = '';
          let carrierGln = '';
          let carrierContactName = '';
          let carrierContactEmail = '';
          let carrierPhoneCountryCode = '';
          let carrierPhoneContactNumer = '';
          let carrierContactCountry = '';
          let carrierContactAddress1 = '';
          let carrierContactAddress2 = '';
          let carrierContactCity = '';
          let carrierContactState = '';
          let carrierContactPostalcode = '';
          if (btnClicked === 'create') {
            orgName = elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val();
            scacCode = elsPage.carrierSection.find('[name=new-scac-code]').val();
            carrierGln = elsPage.carrierSection.find('[name=new-carrier-gln]').val();
            carrierContactName = elsPage.carrierSection.find('[name=new-carrier-contact-name]').val();
            carrierContactEmail = elsPage.carrierSection.find('[name=new-carrier-contact-email]').val();
            carrierPhoneCountryCode = elsPage.carrierSection.find('[name=new-phone-code]').val();
            carrierPhoneContactNumer = elsPage.carrierSection.find('[name=new-phone-number]').val();
            carrierContactCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
            carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
            carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
            carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
            carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();
            carrierContactPostalcode = elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val();
          } else if (btnClicked === 'found') {
            orgName = elsPage.carrierSection.find('[name=carrier-section-org-name]').val();
            scacCode = elsPage.carrierSection.find('[name=scac-code]').val();
            carrierGln = elsPage.carrierSection.find('[name=carrier-gln]').val();
            carrierContactName = elsPage.carrierSection.find('[name=carrier-contact-name]').val();
            carrierContactEmail = elsPage.carrierSection.find('[name=carrier-contact-email]').val();
            carrierPhoneCountryCode = elsPage.carrierSection.find('[name=phone-code]').val();
            carrierPhoneContactNumer = elsPage.carrierSection.find('[name=phone-number]').val();
            carrierContactCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
            carrierContactAddress1 = elsPage.carrierSection.find('[name=carrier-contact-address1]').val();
            carrierContactAddress2 = elsPage.carrierSection.find('[name=carrier-contact-address2]').val();
            carrierContactCity = elsPage.carrierSection.find('[name=carrier-contact-city]').val();
            carrierContactState = elsPage.carrierSection.find('[name=carrier-contact-state]').val();
            carrierContactPostalcode = elsPage.carrierSection.find('[name=carrier-contact-postalcode]').val();

          } else {
            orgName = $("#org-facility-form").find('[name=carrier-section-org-name]').val();
            scacCode = $("#org-facility-form").find('[name=scac-code]').val();
            carrierGln = $("#org-facility-form").find('[name=carrier-gln]').val();
            carrierContactName = $("#org-facility-form").find('[name=carrier-contact-name]').val();
            carrierContactEmail = $("#org-facility-form").find('[name=carrier-contact-email]').val();
            carrierPhoneCountryCode = $("#org-facility-form").find('[name=phone-code]').val();
            carrierPhoneContactNumer = $("#org-facility-form").find('[name=phone-number]').val();
            carrierContactCountry = $("#org-facility-form").find('[name=carrier-contact-country]').val();
            carrierContactAddress1 = $("#org-facility-form").find('[name=carrier-contact-address1]').val();
            carrierContactAddress2 = $("#org-facility-form").find('[name=carrier-contact-address2]').val();
            carrierContactCity = $("#org-facility-form").find('[name=carrier-contact-city]').val();
            carrierContactState = $("#org-facility-form").find('[name=carrier-contact-state]').val();
            carrierContactPostalcode = $("#org-facility-form").find('[name=carrier-contact-postalcode]').val();
          }

          let carrierAddr = {};
          carrierAddr.orgName = orgName;
          carrierAddr.scacCode = scacCode;


          if (!(typeof cmrCarrierAddressObj === 'undefined')) {
            carrierAddr = Object.assign(carrierAddr, cmrCarrierAddressObj);
          } else {
            carrierAddr.cadAddress1 = carrierContactAddress1;
            carrierAddr.cadAddress2 = carrierContactAddress2;
            carrierAddr.cadCity = carrierContactCity;
            carrierAddr.cadState = carrierContactState;
            carrierAddr.cadZipcode = carrierContactPostalcode;
            carrierAddr.cadCountry = carrierContactCountry;
          }



          // const formEl = btnClicked.closest("form");
          // let cadId = formEl.find(".cadId").val();
          // let cadStatus = formEl.find('.cadStatus').val();
          // formEl.get
          let orgType = elsPage.orgType.val();
          let saveOrgCarrierURL = carrierSubmitURL;
          submitModalFlow.showLoadingModal();
          $.ajax({
            data: {
              //carrierAddr: JSON.stringify([carrierAddr]),
              orgName: orgName,
              orgId: organizationId,
              newOrgId: orgId,
              orgType: orgType,
              cmrCarrier: JSON.stringify({
                carScac: scacCode,
                carGln: carrierGln,
                carContactName: carrierContactName,
                carContactEmail: carrierContactEmail,
                carPhoneCountryCode: carrierPhoneCountryCode,
                carContactPhone: carrierPhoneContactNumer,
                cmrAddress: {
                  cadAddress1: carrierAddr.cadAddress1,
                  cadAddress2: carrierAddr.cadAddress2,
                  cadCity: carrierAddr.cadCity,
                  cadState: carrierAddr.cadState,
                  cadZipcode: carrierAddr.cadZipcode,
                  cadCountry: carrierAddr.cadCountry
                }
              }),
              carrierTeamMemberObj: JSON.stringify(teamMembersObjForSubmit)

            },
            url: saveOrgCarrierURL,
            dataType: "JSON",
            type: 'POST',
            success: function (data) {
              EditChecker.setPageClean();
              submitModalFlow.hideAllModals();
              submitModalFlow.showSuccessModal();
              setTimeout(function () {
                location.href = carrierDetailsPageUrl + "&orgId=" + data;
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

            },
            error: function (data) {
              submitModalFlow.hideAllModals();
              submitModalFlow.showFailureModal();
            }
          });
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  }


  function checkFacilityTypesHC(orgFormEle) {
    if (isHoneyComb) {
      let checked = $("#" + orgFormEle[0].id + " input:checkbox:checked").length > 0;
      if (!checked) {
        $(".errorMsgForFacilityTypeCheckbox").show();
        return false;
      } else {
        $(".errorMsgForFacilityTypeCheckbox").hide();
        return true;
      }
    } else {
      return true;
    }
  }

  function prepareDataForBrokerSubmit() {
    let brokerObjMap = {};
    brokerObjMap = {
      brokerOrgName: elsPage.brokerSection.find('[name=broker-org-name]').val(),
      brokerOrgAddress1: elsPage.brokerSection.find('[name=broker-org-address1]').val(),
      brokerOrgAddress2: elsPage.brokerSection.find('[name=broker-org-address2]').val(),
      brokerOrgState: elsPage.brokerSection.find('[name=broker-org-state]').val(),
      brokerOrgCity: elsPage.brokerSection.find('[name=broker-org-city]').val(),
      brokerOrgZipcode: elsPage.brokerSection.find('[name=broker-org-zipcode]').val(),
      brokerOrgCountry: elsPage.brokerSection.find('[name=broker-org-country]').val(),
      brokerOrgContactName: elsPage.brokerSection.find('[name=broker-org-contact-name]').val(),
      brokerOrgEmail: elsPage.brokerSection.find('[name=broker-org-email]').val(),
      brokerOrgPhone: elsPage.brokerSection.find('[name=phone-number]').val(),
      brokerOrgPhoneCode: elsPage.brokerSection.find('[name=phone-code]').val(),
      affiliatedCarrierList: elsPage.brokerSection.find('[name=find-carriers-for-broker]').val()
    };
    if (editForm) {
      brokerObjMap.brokerOrgId = organizations.orgId;
      brokerObjMap.cadId = organizations.cmrAddress[0].cadId;
    }
    return brokerObjMap;
  }

  function prepareTeamMemberForSubmit(orgTypeVal) {
    let teamMembersObjMap = [];
    for (let i = 0; i < teamMemberArray.length; i++) {
      let teamObj = {};
      if ($("#team-member-org-type-" + i).val() == orgTypeVal) {
        teamObj.userId = $('#team-member-user-id-' + i).val();
        if ($("#team-member-edit-" + i).is(":visible") || (!isNullOrUndefined(teamObj.userId) && teamObj.userId !== "")) {
          teamObj.userName = $('#car-team-member-username-' + i).val();
          teamObj.firstName = $("#car-team-member-first-name-" + i).val();
          teamObj.lastName = $("#car-team-member-last-name-" + i).val();
          teamObj.organizationTitle = $("#org-title-" + i).val();
          teamObj.emailAddress = $("#car-team-member-email-" + i).val();
          teamObj.phoneCode = $("#car-team-member-phone-code-" + i).val();
          teamObj.phoneNumber = $("#car-team-member-phone-" + i).val();
          if ($("#team-member-edit-" + i).is(":hidden")) {
            teamObj.action = 'remove';
          } else {
            teamObj.action = 'save';
          }
          teamMembersObjMap.push(teamObj);
        }
      }
    }
    return teamMembersObjMap;
  }

  function saveModalHandler() {
    if (!isOrgDuplicate) {
      if (elsPage.orgType.val() != 'Transportation Broker') {
        const submitModalFlow = new SubmitModalFlow({
          confirmModalTitle: "Save Network Facility Organization",
          confirmModalBody: '<div class="q-pad-all-xl">Once saved this network facility organization can be assigned to existing and new facilities. When you create a new or edit a facility in the facilities page, you may assign this network facility organization as the owner.</div>',
          confirmModalBtnText: "Save",
          onConfirmClick: function () {
            let orgName = elsPage.organizationName.val();
            let orgType = elsPage.orgType.val();
            let saveOrgFacURL = submitURL;
            submitModalFlow.showLoadingModal();
            $.ajax({
              data: {
                facilityArray: JSON.stringify(facilityArray),
                orgName: orgName,
                orgId: organizationId,
                newOrgId: orgId,
                orgType: orgType

              },
              url: saveOrgFacURL,
              dataType: "JSON",
              type: 'POST',
              success: function (data) {
                EditChecker.setPageClean();
                submitModalFlow.hideAllModals();
                submitModalFlow.showSuccessModal();
                setTimeout(function () {
                  location.href = detailsPageUrl + "&orgId=" + data;
                }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

              },
              error: function (data) {
                submitModalFlow.hideAllModals();
                submitModalFlow.showFailureModal();
              }
            });
          }
        });
        submitModalFlow.init();
        submitModalFlow.showConfirmModal();
      } else {
        const brokerControllerObj = prepareDataForBrokerSubmit();
        const teamMembersObjForSubmit = prepareTeamMemberForSubmit("broker");
        const submitModalFlow = new SubmitModalFlow({
          confirmModalTitle: "Save Transportation Broker Organization",
          confirmModalBody: '<div class="q-pad-all-xl">Once saved, this transportation broker organization may be assigned to ASNs to handle the assignment of carriers for shipments. Any team members created under this organization may log in and begin assigning carriers to your scheduled appointments</div>',
          confirmModalBtnText: "Save",
          onConfirmClick: function () {
            let orgName = elsPage.organizationName.val();
            let orgType = elsPage.orgType.val();
            let saveOrgFacURL = submitURL;
            submitModalFlow.showLoadingModal();
            $.ajax({
              data: {
                brokerOrgObj: JSON.stringify(brokerControllerObj),
                brokerTeamMemberObj: JSON.stringify(teamMembersObjForSubmit),
                orgName: orgName,
                orgId: organizationId,
                newOrgId: orgId,
                orgType: orgType
              },
              url: saveOrgFacURL,
              dataType: "JSON",
              type: 'POST',
              success: function (data) {
                EditChecker.setPageClean();
                submitModalFlow.hideAllModals();
                submitModalFlow.showSuccessModal();
                setTimeout(function () {
                  location.href = brokerOrgDetailsUrl + "&orgId=" + data;
                }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

              },
              error: function (data) {
                submitModalFlow.hideAllModals();
                submitModalFlow.showFailureModal();
              }
            });
          }
        });
        submitModalFlow.init();
        submitModalFlow.showConfirmModal();
      }
    }
  }

  function generateModals() {
    selectFromOrgModal = $(render(sharedModalHtml, {
      title: 'Select Organization',
      subtitle: "Select an organization for this facility",
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn organization-select-btn">Save as Organization</a>',
      body: render(selectOrgModalBodyHtml, {
        dropdownList: renderOrganizationValues()
      }),
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));
    saveTeamMemberModel = $(render(sharedModalHtml, {
      title: 'Save Organization Team Member ',
      body: "<div class='q-pad-all-xl'>Once saved this team member will receive log in credentials and can begin carrying out the roles and privileges they have been assigned.</div>",
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-team-member-dialog-btn">Save</a>',

      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));
    continueModal = $(render(sharedModalHtml, {
      title: 'Continue Editing',
      footerBtns: '<a href="#" class="base-btn v2-btn" id="abandon-form-btn">Abandon Form</a><a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Continue Editing</a>',
      body: "<div class='q-pad-all-xl'>You will lose information on the open facility form by editing another facility.Would you like to continue editing the form you are on ?</div>",
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));

    orgNameDuplicateModal = $(render(sharedModalHtml, {
      title: 'Organization Already Exists',
      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
      body: '<div class="q-pad-all-xl">The organization you have entered already exists. To continue adding this organization, please update the name as entered. If your intent is to add a facility to this organization, you may do so within the existing detail page of the organization. If you believe this to be in error, please contact your dedicated customer support specialist</div>',
      topCloseBtn: true,
      autoHideTop: true,
      modalDialogClass: "q-modal-dialog-800"
    }));

    carrierBrokerModal = $(render(
      modalHtml,
      {
        title: 'Create Organization',
        leftAlignTitle: true,
        modalDialogClass: "q-modal-dialog-500",
        body: createCarrierOrBrokerModalBodyHtml,
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
       <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" target="_blank" class="base-btn purple-btn 
       continue-btn">Continue</a>
         `
      }
    ));

    $('body').append(selectFromOrgModal, continueModal, orgNameDuplicateModal, saveTeamMemberModel, carrierBrokerModal);
  }

  function renderOrganizationValues() {
    let returnTypeList = "";
    returnTypeList = organizationList.map((el) => {
      return render("<option value = '{%-key %}'>{%-value %}</option>", {
        key: el.orgId,
        value: el.orgName
      });
    });
    return returnTypeList.join('');
  }

  function orgSelectBtnHandler() {
    selectFromOrgModal.modal('hide');
    orgId = elsModal.dropDownOption.find('option:selected').val();
    orgName = elsModal.dropDownOption.find('option:selected').text();
    elsPage.organizationName.attr("value", orgId);
    elsPage.organizationName.val(orgName);
  }


  // Function that hides expandable sections and Update btns on pge load
  function hideAllExpandableSectionsOnPageLoad() {
    mainEl.find(elsMap.customExpanderTarget).hide();
    mainEl.find(elsMap.masterFormSectionParent).hide();
    mainEl.find(elsMap.facilityUpdateSectionBtn).hide();
    mainEl.find(elsMap.facilityCancelSectionBtn).hide();
  }


  function selectOrgBtnHandler() {
    selectFromOrgModal.modal('hide');
    elsPage.organizationName.val();
  }

  function showOrganizationSelectModal() {
    selectFromOrgModal.modal('show');
  }

  function showAbandonFormModal() {
    continueModal.modal('show');
  }

  function hideAbandonFormModal() {
    continueModal.modal('hide');
  }


  function showOrgNameDuplicateModal() {
    orgNameDuplicateModal.modal('show');
  }



  function validateOrgName() {
    let isValid = true;
    const orgType = elsPage.orgType.val();
    const orgPrevious = organizations.orgName;
    let orgName = "";
    if (orgType == 'Transportation Broker') {
      orgName = elsPage.brokerSection.find("[name=broker-org-name]").val();
    }
    else if (orgType == 'Carrier') {
      orgName = elsPage.carrierSection.find("[name=new-carrier-section-org-name]").val();
    } else {
      orgName = elsPage.organizationName.val();
    }
    if (orgName != orgPrevious) {
      $.ajax({
        async: false,
        data: {
          orgName: orgName
        },
        url: validateOrgNameUrl,
        dataType: "JSON",
        type: 'POST',
        success: function (data) {
          isOrgDuplicate = data.response;
          if (data.response == true) {
            $(".dup-orgName").css("display", "");
            if (elsPage.orgType.val() == 'Facility Network') {
              showOrgNameDuplicateModal();
            } else {
              isValid = false;
            }
          }
        }
      });
    }
    if (isValid)
      $(".dup-orgName").css("display", "none");
    else
      $(".dup-orgName").css("display", "");
    return isValid;
  }

  function getHcmbFacilityTypes(cmrAddressObj) {
    if (isHoneyComb) {
      return render(facilityTypeHtml, {
        ...cmrAddressObj,
        facilityTypes: getRenderedFacilityTypes(facilityTypes)
      });
    }
  }


  function showStaticForm() {
    editFlag = true;
    organizations.orgName = elsPage.organizationName.val();
    //If Org Name is valid, hide the First Add facility button and Show the static Facility Form     
    //elsPage.addFacilitySection.hide();//HB-12202
    elsPage.nextAddfacilityBtn.show();
    mainEl.find(elsMap.masterFormSectionParent).show();
  }

  function createStaticForm() {
    const orgNewFormHtml = $(render(facilityWrapperTemplate,
      {
        masterForm: render("<form id='master-form'><div class='q-section master-form'>"),
        facilityDetails: render(facilityDetailsHtml, {
          dupFacName: duplicateCadLocationNameMessage,
          dupFacId: duplicateAddressIdMessage,
          rmsTypes: getRMSFacilityTypes()
        }),
        hcmbFacilityTypes: getHcmbFacilityTypes(),
        rmsFacilityTypes: getRmsFacilityTypes(),
        facilityAddress: render(facilityAddressHtml, {
          countries: getRenderedCountries(countries)
        }),
        facilityContact: render(facilityContactHtml, {
          phoneCodes: getRenderedPhoneCodes(phoneCodes)
        }),
        facilityName: "Facility Details",
        masterFormClass: "master-form-section",
        actionButtons: render(require("./html/createOrganization/addFacilityButtons.html")),
        sectionIsExpandable: '',
        isHoneyComb
      }
    ));
    elsPage.facilityFormDiv.append(orgNewFormHtml);
    mainEl.find(elsMap.masterFormSectionParent).hide();
    instantiateSelect2(orgNewFormHtml.find('.select2-select'));
    //orgNewFormHtml.find('.vendorSelectAuthorization').hide();
    //orgNewFormHtml.find('.inboundClassification').hide();
    //orgNewFormHtml.find('.phone-format').inputmask({mask: "(999) 999-9999"});
    
    orgNewFormHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
    orgNewFormHtml.find(".rms-facility-type").val("").trigger('change');
    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
    orgNewFormHtml.find(".facility-country").val(defaultCountry).trigger('change');
    const editForm = mainEl.data("edit-form");
    if (!editForm) { 
      orgNewFormHtml.find(".facility-phone-code").val("+1").trigger('change');
      orgNewFormHtml.find('.facility-phone-code').on("change", handleFacilityPhoneValidation);
    }
    instantiateSwitchery(orgNewFormHtml.find("#return-auth-req"), {});
    validator = $('#master-form').validate(validationOpts);
    validator.settings.ignore = ":disabled, :hidden";

    activeFormElement = $('#master-form');
  }

  function handleFacilityPhoneValidation(){
      let facPhoneCode = $('.facility-phone-code').find(":selected").val();
      let facPhoneContactNumber=$(".facility-phone-contact-number"); 
      facPhoneContactNumber.val(''); //Reset the value
      if (facPhoneCode === "+1") {
        facPhoneContactNumber.addClass("phoneUS");
        facPhoneContactNumber.removeClass("phoneNonUS")
        facPhoneContactNumber.addClass("phone-format");        
        facPhoneContactNumber.attr("placeholder", "___-____");
        facPhoneContactNumber.inputmask("(999) 999-9999"); 
        
      } else {
        facPhoneContactNumber.addClass("phoneNonUS")
        facPhoneContactNumber.removeClass("phoneUS");
        facPhoneContactNumber.removeClass("phone-format");
        facPhoneContactNumber.removeAttr('placeholder'); 
        facPhoneContactNumber.inputmask("");    
        
        let val= facPhoneContactNumber.val();						
        if(val){
          const v=val.replace(/[^0-9.]/g, "");
          facPhoneContactNumber.val(v);
        }
      }
  }

  function handleFacilityPhoneValidationByIndex(index){
    let facPhoneCode = $('#phone-code'+index).find(":selected").val();
    let facPhoneContactNumber=$("#phone-number"+index); 
    if (facPhoneCode === "+1") {
      facPhoneContactNumber.addClass("phoneUS");
      facPhoneContactNumber.removeClass("phoneNonUS");
      facPhoneContactNumber.attr("placeholder", "___-____");
      facPhoneContactNumber.inputmask("(999) 999-9999"); 
    } else {
      let facPhoneContactValue=facPhoneContactNumber.val();
      facPhoneContactValue=facPhoneContactValue.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');
      facPhoneContactNumber.val(facPhoneContactValue);
      facPhoneContactNumber.addClass("phoneNonUS");
      facPhoneContactNumber.removeClass("phoneUS");
      facPhoneContactNumber.removeAttr('placeholder'); 
      facPhoneContactNumber.inputmask("");   
      
      let val= facPhoneContactNumber.val();		
      if(val){
        const v=val.replace(/[^0-9.]/g, "");
        facPhoneContactNumber.val(v);
      }
    }
}

  function getRMSFacilityTypes(arrayIndex) {
    if (!isHoneyComb) {
      return render(require("./html/createOrganization/rmsFaciltyTypes.html"), {
        arrayIndex,
        rmsFacilityTypes: getRenderedRmsFacility(retailerFacilityForRMS),
        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts),
        rmsCasAccounts: getRenderedCasAccounts(retailerCasAccounts)
      });
    }
  }

  function getRenderedCasAccounts(retailerCasAccounts) {
    const retailerFacilityHtml = '<option value="{%- casAccount.ccaId %}">{%- casAccount.ccaCasAccountnNumber %}</option>';
    const response = _.map(retailerCasAccounts, (casAccount) => {
      return render(retailerFacilityHtml, {
        casAccount: casAccount
      });
    });

    return response.join("");
  }

  function handleCountryChange(e) {
    const formEl = $(this).closest("form");
    handleSwitchingStateInput(formEl);
  }

  
  function handleSwitchingStateInput(formEl) {
    let countryVal = formEl.find('.facility-country').val();
    
    let response = '';
    $(countries).each(function() {
      if(this.conId.toString() === countryVal.toString()) {
        response=this.conPhoneCode.toString() 
      }
    });

    if(response!=''){
      $(".facility-phone-code").val(response).change();
    }
    if (countryVal == "1" || countryVal == "2") {

      formEl.find(".facility-stateText-wrapper").hide();
      formEl.find(".facility-state-wrapper").show();
      getRenderedStatesorProvince(countryVal, formEl);
      $(".broker-org-state-required").text('State/Province/Region *');      
      $(".broker-org-state").addClass("required"); 
      
      $(".facility-state-required").text('State/Province/Region *');      
      $(".facility-state").addClass("required");  
    } else {
      formEl.find(".facility-stateText-wrapper").show();
      formEl.find(".facility-state-wrapper").hide();
      $(".broker-org-state-required").text('State/Province/Region');     
      $(".broker-org-state").removeClass("required");
      
      $(".facility-state-required").text('State/Province/Region');      
      $(".facility-state").removeClass("required"); 
      $(".facility-stateText").removeClass("required");       
    }
    

    let checkZipCode = false;
      $(countries).each(function() {
        if(this.conId.toString() === countryVal.toString()) {
            if(this.conPostalCodeRequired.toString() === "Y"){
              checkZipCode=true;
            }
        }
      });
      if(checkZipCode){
        $(".broker-org-zipcode-required").text('Postal Code *');  
        $(".broker-org-zipcode").addClass("required");   
        $(".facility-zip-required").text('Postal Code *');  
        $(".facility-zip").addClass("required");  
      } else{
        $(".broker-org-zipcode-required").text('Postal Code');
        $(".broker-org-zipcode").removeClass("required");
        $(".facility-zip-required").text('Postal Code');
        $(".facility-zip").removeClass("required");
      } 

    let validateAddressForCountry=false;
    $(validationReqdCountries).each(function() {
     if(this.cdmMeaning.toString() === countryVal.toString()) {
       validateAddressForCountry = true;
       return false;
     } 
     });
     if(validateAddressForCountry){
      $(".country_not_supported").hide();   
      $(".facility-country-not-supported").hide();              
    }else{
      $(".country_not_supported").show();
      $(".facility-country-not-supported").show();
    }
    let facilityContactPhoneCode = formEl.find('.facility-contact-phone-code').val();
    let facilityPhoneContactNumber=$(".facility-phone-contact-number");
    if (facilityContactPhoneCode === "+1") {
      facilityPhoneContactNumber.addClass("phoneUS");
      facilityPhoneContactNumber.removeClass("phoneNonUS");
      facilityPhoneContactNumber.attr("placeholder", "___-____");
      facilityPhoneContactNumber.addClass("phone-format");
      facilityPhoneContactNumber.inputmask("(999) 999-9999");
    } else {
      facilityPhoneContactNumber.addClass("phoneNonUS");
      facilityPhoneContactNumber.removeClass("phoneUS");
      facilityPhoneContactNumber.removeClass("phone-format");
      facilityPhoneContactNumber.removeAttr('placeholder'); 
      facilityPhoneContactNumber.inputmask("");

      let val= facilityPhoneContactNumber.val();						
      if(val){
       const v=val.replace(/[^0-9.]/g, "");
        facilityPhoneContactNumber.val(v);
      }

    }
  }
  function handleRmsFacilityTypeChange(e) {
    const formEl = $(this).closest("form");
    if (formEl.find(".rms-facility-type").val() === "vendor") {
      if (formEl.find(".return-auth-req").is(":checked")) {
        instantiateSwitchery(formEl.find(".return-auth-req"), true);
      } else {
        instantiateSwitchery(formEl.find(".return-auth-req"), false);
      }

      formEl.find('.vendorSelectAuthorization').show();
      formEl.find('.inboundClassification').hide();
    }
    else if (formEl.find(".rms-facility-type").val() === "return") {
      formEl.find('.inboundClassification').show();
      formEl.find('.vendorSelectAuthorization').hide();
    } else {
      formEl.find('.inboundClassification').hide();
      formEl.find('.vendorSelectAuthorization').hide();
    }

  }


  function getRenderedStatesorProvince(countryVal, formEl) {
    
    const stateTypeSelect = formEl.find(".facility-state");
    stateTypeSelect.html('');
    let defaultSelectText = "";
    if (countryVal == "1") {
      defaultSelectText = "Select State";
    } else {
      defaultSelectText = "Select Province";
    }
    let option = $('<option />');
    option.attr('value', "-1").text(defaultSelectText);
    option.attr('selected', 'selected');
    option.attr('disabled', 'disabled');
    stateTypeSelect.append(option);
    if (countryVal == "1") {
      $(usaStates).each(function () {
        let option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        stateTypeSelect.append(option);
      });
    }
    else if (countryVal == "2") {
      $(caProvinces).each(function () {
        let option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        stateTypeSelect.append(option);
      });
    }
    stateTypeSelect.addClass("select2-select");
    instantiateSelect2(stateTypeSelect);
  }

  //Render functions for options to be displayed in the select drop downs 

  function getRenderedRmsFacility(retailerFacilityForRMS) {
    const retailerFacilityHtml = '<option value="{%- rmsFacilityType.cdmValue %}">{%- rmsFacilityType.cdmMeaning %}</option>';
    const response = _.map(retailerFacilityForRMS, (rmsFacilityType) => {
      return render(retailerFacilityHtml, {
        rmsFacilityType: rmsFacilityType
      });
    });

    return response.join("");
  }

  function getRenderedFedexAccounts(retailerFacilityForRMS) {
    const retailerFacilityHtml = '<option value="{%- rmsFacilityType.cmtId %}">{%- rmsFacilityType.cmtAccountNo %}</option>';
    const response = _.map(retailerFacilityForRMS, (rmsFacilityType) => {
      return render(retailerFacilityHtml, {
        rmsFacilityType: rmsFacilityType
      });
    });

    return response.join("");
  }

  function getRenderedCountries(countries) {
    const optionHtml = '<option value="{%- country.conId %}">{%- country.conName %}</option>';
    const response = _.map(countries, (country) => {
      return render(optionHtml, {
        country: country
      });
    });

    return response.join("");
  }

  function getRenderedPhoneCodes(phoneCodes) {
    const phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}">{%- phoneCode.conPhoneText %}</option>';
    let count = 0;
    const response = _.map(phoneCodes, (phoneCode) => {
      if (phoneCode.conPhoneCode === '+1' && count == 0) {
        phoneCode.conPhoneText = "United States of America/Canada +1";
        count++;
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode
        });
      } else if (phoneCode.conPhoneCode !== '+1') {
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode
        });
      }
    });
    return response.join("");
  }
  //Render functions for the Facility Type checkbox
  function getRenderedFacilityTypes(facilityTypes) {
    const facilityTypeHtml = require("./html/createOrganization/facilityType.html");
    const response = _.map(facilityTypes, (facility) => {
      return render(facilityTypeHtml, {
        facility: facility
      });
    });

    return response.join("");
  }

  //Render functions for the Inbound classification Types
  function getRenderedInboundTypes(inboundClassificationTypes) {
    const inboundClassificationHtml = require("./html/createOrganization/inboundClassification.html");
    const response = _.map(inboundClassificationTypes, (inboundClassificationItem) => {
      return render(inboundClassificationHtml, {
        inboundClassificationItem: inboundClassificationItem
      });
    });

    return response.join("");
  }

  function expandFacilitySectionClickHandler(e) {
    btnClickedEdit = $(this);
    e.preventDefault();
    if ($(this).hasClass('disabled')) {
      //Don't Do Anything
    }
    else if (mainEl.find(elsMap.masterFormSectionParent).is(":visible")) {
      showAbandonFormModal();
    } else {
      abandonFormHandler(e);
    }
  }

  function expandFacilitySection(btnClicked) {
    //Hide the static form when the facility is expanded, Need to disable the Edit button for other facilities 
    mainEl.find(elsMap.masterFormSectionParent).hide();
    const targetSection = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.customExpanderTarget);
    //Disable all the other Edit Buttons for the collapsed facilities when one active 
    $('.facility-edit-section-btn').not(this).each(function () {
      $(this).addClass('disabled');
    });
    validator = targetSection.closest("form").validate(validationOpts);
    validator.settings.ignore = ":disabled, :hidden";

    elsPage.cancelMainFormBtn.addClass('disabled');
    elsPage.nextAddfacilityBtn.addClass('disabled');
    elsPage.saveVendorOrgAddressBtn.addClass('disabled');
    const updateBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityUpdateSectionBtn);
    const cancelBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityCancelSectionBtn);
    btnClicked.hide();
    updateBtn.show();
    cancelBtn.show();
    targetSection.slideDown();
  }

  function cancelFormClickHandler(e) {
    showAbandonFormModal();
  }


  function cancelEditFacilityClickHandler(e) {

    e.preventDefault();
    //show the static master form again once we hit cancel on the collapsed facility editing 
    const btnClicked = $(this);
    const formEl = btnClicked.closest("form");
    formEl.validate().resetForm();
    //Enable the Edit Buttons for the other collapsed facilities when Cancel is clicked 
    $('.facility-edit-section-btn').each(function () {
      $(this).removeClass('disabled');
    });
    elsPage.nextAddfacilityBtn.removeClass('disabled');
    elsPage.cancelMainFormBtn.removeClass('disabled');
    elsPage.saveVendorOrgAddressBtn.removeClass('disabled');

    const targetSection = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.customExpanderTarget);
    const updateBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityUpdateSectionBtn);
    const cancelBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityCancelSectionBtn);
    const editBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityEditSectionBtn);
    btnClicked.hide();
    updateBtn.hide();
    editBtn.show();
    targetSection.slideUp();

  }

  function collapseFacilitySectionClickHandler(e) {
    e.preventDefault();
    const btnClicked = $(this);
    collapseFacilitySection(btnClicked);
  }

  function collapseFacilitySection(btnClicked) {
    const formEl = btnClicked.closest("form");
    activeFormElement = formEl;
    //if (!formEl.find('.dup-facName').is(':visible') && !formEl.find('.dup-facId').is(':visible')) {
    if (validateForm(formEl) && checkFacilityTypesHC(formEl)) {
      const arrayIndex = formEl.data("obj-id");
      const oldCmrAddressObj = facilityArray[arrayIndex];
      const newCmrAddressObj = prepareDataForSubmit(formEl, false);
      if (userChangedAddress(oldCmrAddressObj, newCmrAddressObj)) {
        validateAddressModal(formEl);
      } else {
        addAddressToStore(newCmrAddressObj, arrayIndex);
        hideEditForm(formEl);
      }
      $('.facility-edit-section-btn').each(function () {
        $(this).removeClass('disabled');
      });
      elsPage.nextAddfacilityBtn.removeClass('disabled');
      elsPage.saveVendorOrgAddressBtn.removeClass('disabled');
      elsPage.cancelMainFormBtn.removeClass('disabled');
    }
  }

  function userChangedAddress(oldAddress, newAddress) {
    if (!(_.isUndefined(oldAddress.cadAddress1)) && !(_.isUndefined(newAddress.cadAddress1))
      && (oldAddress.cadAddress1 != newAddress.cadAddress1)) {
      return true;
    } else if (!(oldAddress.cadAddress2 == null) && !(newAddress.cadAddress2 == "")
      && (oldAddress.cadAddress2 != newAddress.cadAddress2)) {
      return true;
    } else if (!(_.isUndefined(oldAddress.cadState)) && !(_.isUndefined(newAddress.cadState))
      && (oldAddress.cadState != newAddress.cadState)) {
      return true;
    } else if (!(_.isUndefined(oldAddress.cadCity)) && !(_.isUndefined(newAddress.cadCity))
      && (oldAddress.cadCity != newAddress.cadCity)) {
      return true;
    } else if (!(_.isUndefined(oldAddress.cadCountry)) && !(_.isUndefined(newAddress.cadCountry))
      && (oldAddress.cadCountry != newAddress.cadCountry)) {
      return true;
    } else if (!(_.isUndefined(oldAddress.cadZipcode)) && !(_.isUndefined(newAddress.cadZipcode))
      && (oldAddress.cadZipcode != newAddress.cadZipcode)) {
      return true;
    }
    return false;
  }

  function hideEditForm(editFormEl) {
    //Enable the Edit Buttons for the other collapsed facilities when Cancel is clicked 
    $('.facility-edit-section-btn').each(function () {
      $(this).removeClass('disabled');
    });
    //Update the facility name header text
    const currentFacilityNameHeader = editFormEl.find(".facility-top-name").html(editFormEl.find(".facility-name").val());
    const targetSection = editFormEl.find(elsMap.customExpanderTarget);
    const updateBtn = editFormEl.find(elsMap.facilityUpdateSectionBtn);
    const editBtn = editFormEl.find(elsMap.facilityEditSectionBtn);
    const cancelBtn = editFormEl.find(elsMap.facilityCancelSectionBtn);
    updateBtn.hide();
    cancelBtn.hide();
    editBtn.show();
    targetSection.slideUp();
  }

  //Validate the current expanded form and create the section with both old and new contents here 
  function addFacilityHandler(e) {
    if ($('.next-add-facility-btn').hasClass('disabled')) {
      e.preventDefault();
    } else {
      if (!editFlag) {
        showStaticForm();
      } else {
        const orgFormEle = mainEl.find("#master-form");
        const isValidOrgForm = validateForm(orgFormEle);
        if (isValidOrgForm && checkFacilityTypesHC(orgFormEle)) {
          validateAddressModal(orgFormEle);
        }
      }
    }
  }
  //HB-12085
  function addCarrierHandler(e) {
    e.preventDefault();

    elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
    elsPage.carrierDetailsDiv.addClass('hidden');
    elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');

    teamMemberObj = {};
    teamMemberArray = [];

    $('.team-member-edit').remove();
    $('.team-member-section-details').remove();



    if (this.id === 'use-found-carrier-btn') {
      btnClicked = 'found';
      elsPage.createCarrierBtn.removeAttr('disabled');
      newCarrierHandler(carData, btnClicked);
      elsPage.carrierSection.find('.carrier-by-scac-country').trigger('change');
    }
    else if (this.id === 'create-carrier-btn') {
      btnClicked = 'create';
      elsPage.createCarrierBtn.attr('disabled', 'disabled');
      elsPage.carrierDetailsDiv.addClass('hidden');
      newCreateCarrierHandler(btnClicked);
    }
    newCarrierTeamMemberDetailsHandler();
  }
  function getRenderedScacListByMerchant(carrierListByMerchant) {

    let affiliatedCarrrierOption = (carrierListByMerchant).map((carrier) => {
      return render(optionTemplateHtml, {
        targetKey: carrier.orgId,
        text: carrier.orgName
      });
    });

    return affiliatedCarrrierOption.join("");
  }



  let carrierScacCode;
  function checkValue(scacCode) {
    var i;
    for (i = 0; i < cmrCarrierScacList.length; i++) {
      if (scacCode === cmrCarrierScacList[i].carScac /* || scacCode.toUpperCase() === cmrCarrierScacList[i].carScac */ ) {
        carrierScacCode = cmrCarrierScacList[i].carScac;
        return true;
      }

    }

  }

  //duplicate scac code  check
  function validateScacCode() {
   $('.scac-error-page').remove();
    let scacCode = elsPage.carrierSection.find('[name=new-scac-code]').val();
    if (checkValue(scacCode)) {
      var valScacCode;
      $.ajax({
        data: {
          carrierScac: carrierScacCode
        },
        url: checkSCACExistsForRetailerUrl,
        //async: false,
        dataType: 'JSON',
        type: 'POST',
        success: function (dataResponse) {
          if (dataResponse == true) {//right one
            //if (dataResponse === false) {
            // display 2nd error
            scacDetails = "";
            valScacCode = 'retailer';
            validateScacHandler(scacDetails, valScacCode);
          } else {
            ///make ajax call to get checkSCACExistsForCarrier
            $.ajax({
              data: {
                //  orgId:orgId,
                scacId: carrierScacCode
              },
              url: checkSCACExistsForCarrierUrl,
              //async: false,
              dataType: 'JSON',
              type: 'POST',
              success: function (dataResponse) {
                if (dataResponse != null) {
                  // display 1st error
                  scacDetails = dataResponse;
                  valScacCode = 'carrier';
                  validateScacHandler(scacDetails, valScacCode);
                }
              }
            });
          }
        }
      });
    }
  }

  function validateScacHandler(scacDetails, valScacCode) {
    var countryName='';
  if(!isNullOrUndefined(scacDetails[0]) && !isNullOrUndefined(scacDetails[0].cmrAddress.cadCountry)){
    if (scacDetails[0].cmrAddress.cadCountry == 'US') {
      countryName = "United States of America";
    } else if (scacDetails[0].cmrAddress.cadCountry == 'CA') {
      countryName = "Canada";
    } else {
      countryName = scacDetails[0].cmrAddress.cadCountry;
    }
  }
    const validateScacHandlerHtml = $(render(validateScacCodeWrapperTemplate,
      {
        carName: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carName) ? "" : scacDetails[0].carName,
        carScac: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carScac) ? "" : scacDetails[0].carScac,
        carGln: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carGln) ? "" : scacDetails[0].carGln,
        carContactName: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carContactName) ? "" : scacDetails[0].carContactName,
        carPhoneCountryCode: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carPhoneCountryCode) ? "" : scacDetails[0].carPhoneCountryCode,
        carContactPhone: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carContactPhone) ? "" : scacDetails[0].carContactPhone,
       // cadCountry: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cadCountry) ? "" : scacDetails[0].cadCountry,
        cadCountry:countryName,
        cadContactEmail: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadContactEmail) ? "" : scacDetails[0].cmrAddress.cadContactEmail,
        cadAddress1: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadAddress1) ? "" : scacDetails[0].cmrAddress.cadAddress1,
        cadAddress2: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadAddress2) ? "" : scacDetails[0].cmrAddress.cadAddress2,


      }));


    $('#validate-scac-code').append(validateScacHandlerHtml);
    if (valScacCode === 'carrier') {
      $('.assigned-to-retailer').addClass('hidden');
    }
    else if (valScacCode === 'retailer') {
      $('.assigned-to-carrier').addClass('hidden');
      $('.assigned-to-carrier-details').addClass('hidden');
      $('.val-use-found-carrier-btn').addClass('hidden');
    }
  }

  function useCarrierScacCode() {
    isUseFoundCarrierFlow = true;
    $('.scac-error-page').addClass('hidden');
    var orgName = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carName) ? "" : scacDetails[0].carName;
    var carScac = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carScac) ? "" : scacDetails[0].carScac;
    var carGln = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carGln) ? "" : scacDetails[0].carGln;
    var carContactName = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carContactName) ? "" : scacDetails[0].carContactName;
    var carPhoneCountryCode = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carPhoneCountryCode) ? "" : scacDetails[0].carPhoneCountryCode;
    var carContactPhone = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].carContactPhone) ? "" : scacDetails[0].carContactPhone;
    var cadContactEmail = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadContactEmail) ? "" : scacDetails[0].cmrAddress.cadContactEmail;
    var cadCountry = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadCountry) ? "" : scacDetails[0].cmrAddress.cadCountry;
    var cadAddress1 = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadAddress1) ? "" : scacDetails[0].cmrAddress.cadAddress1;
    var cadAddress2 = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadAddress2) ? "" : scacDetails[0].cmrAddress.cadAddress2;
    var cadCity = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadCity) ? "" : scacDetails[0].cmrAddress.cadCity;
    var cadState = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadState) ? "" : scacDetails[0].cmrAddress.cadState;
    var cadZipcode = isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress) ? "" : isNullOrUndefined(scacDetails[0].cmrAddress.cadZipcode) ? "" : scacDetails[0].cmrAddress.cadZipcode;
    var phoneCodes = getRenderedPhoneCodes(phoneCodes);

    instantiateSelect2(elsPage.carrierSection.find('.select2-select'));
    
     elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val(orgName);
     elsPage.carrierSection.find('[name=new-scac-code]').val(carScac);
     elsPage.carrierSection.find('[name=new-carrier-gln]').val(carGln);
     elsPage.carrierSection.find('[name=new-carrier-contact-name]').val(carContactName);
 
     elsPage.carrierSection.find('[name=new-carrier-contact-email]').val(cadContactEmail);
     //elsPage.carrierSection.find('[name=new-phone-code]').val(carPhoneCountryCode);
     elsPage.carrierSection.find('[name=new-phone-number]').val(carContactPhone);
     let facilityCountry = countries.find(obj => obj.conCode == cadCountry);
     elsPage.carrierSection.find('[name=new-carrier-contact-country]').val(facilityCountry.conId).trigger('change');
     elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val(cadAddress1);
     elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val(cadAddress2);
     elsPage.carrierSection.find('[name=new-carrier-contact-city]').val(cadCity);
     elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val(cadZipcode);
   
     elsPage.carrierSection.find('[name=new-carrier-contact-state]').val(cadState).trigger('change');
     elsPage.carrierSection.find('[name=new-phone-code]').val(carPhoneCountryCode).trigger('change');
     elsPage.carrierSection.find('[name=new-carrier-contact-country]').on("change", handleSwitchingCarrierStateInput);
    

     $(".carrier-new-section-details :input").attr("disabled", 'disabled');
 

   

  }

  function onclickCreateCarrier(e) {
    $("#broker-section").hide();
    elsPage.carrierSection.show();
    e.preventDefault();
    elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');
    elsPage.carrierDetailsDiv.addClass('hidden');
    let brokerData = [{ "cadOrganizationName": "", "carPhoneCountryCode": "", "carScac": "", "carName": "", "carContactPhone": "", "carContactName": "", "cmrAddress": { "cadOrganizationName": "", "cadAddress1": "", "cadAddress2": "", "cadZipcode": "", "cadCounty": "", "cadCity": "" } }];
    newCarrierHandler(brokerData);
    newCarrierTeamMemberDetailsHandler();
  }

  const brokerHtml = $(render(transportationBrokerSectionWrapperTemplate,
    {
      data: carData[0],
      countries: getRenderedCountries(countries),
      phoneCodes: getRenderedPhoneCodes(phoneCodes),
      affiliatedCarrrier: getRenderedScacListByMerchant(carrierListByMerchant),
      orgName: isNullOrUndefined(organizations.orgName) ? "" : organizations.orgName,
      cmrAddress: isNullOrUndefined(organizations.cmrAddress) ? "" : organizations.cmrAddress[0]
    }));


  $("#broker-section").append(brokerHtml);
  if (!isNullOrUndefined(organizations) && !isNullOrUndefined(organizations.cmrAddress)) {
    $(".broker-phone-code").val(organizations.cmrAddress[0].cadContactCountryPhoneCode).trigger('change');
    $(".broker-org-country").val(organizations.cmrAddress[0].cadCountry).trigger('change');
  }

  const orgCarrierTeamFormHtml = render(carrierTeamMemberDetailsWrapperTemplate,
    {
      orgType: "broker"
    });

  $("#broker-section").append(orgCarrierTeamFormHtml);

  function tranportationBrokerHandler() {
    $("#broker-section").removeClass('q-display-none');
  }

  // validate the broker contact phoneNumber for "+1" phone code
  $(".broker-phone-number").on('focusout', function (e) {
    setPhoneCodeValidation($(this).val());
  });

  function setPhoneCodeValidation(data) {
    let brokerPhoneCode=$(".broker-phone-code");
    let brokerPhoneNumber=$(".broker-phone-number");
    if (brokerPhoneCode.val() == "+1") {
      brokerPhoneNumber.addClass("phoneUS");
      brokerPhoneNumber.removeClass("phoneNonUS");
    } else {
      brokerPhoneNumber.addClass("phoneNonUS");
      brokerPhoneNumber.removeClass("phoneUS");
      let val= brokerPhoneNumber.val();						
      if(val){
        const v=val.replace(/[^0-9.]/g, "");
        brokerPhoneNumber.val(v);
      }
    }
  }

  // validate email address for broker contact
  $(".broker-org-email").on('focusout', function (e) {
    $(".broker-org-email").addClass("pattern");
  });


  function handleBrokerPhoneValidation() {
    let brokerPhoneCode=$(".broker-phone-code");
    let brokerPhoneNumber=$(".broker-phone-number");
    if (brokerPhoneCode.val() === "+1") {
      brokerPhoneNumber.addClass("phoneUS");
      brokerPhoneNumber.removeClass("phoneNonUS");
      brokerPhoneNumber.attr("placeholder", "___-____");
      brokerPhoneNumber.inputmask("(999) 999-9999");
    } else {
      brokerPhoneNumber.addClass("phoneNonUS");
      brokerPhoneNumber.removeClass("phoneUS");
      brokerPhoneNumber.removeAttr('placeholder'); 
      brokerPhoneNumber.inputmask("");
      let val= brokerPhoneNumber.val();						
      if(val){
       const v=val.replace(/[^0-9.]/g, "");
        brokerPhoneNumber.val(v);
      }
    }

  }

  function handleSwitchingBrokerStateInput() {
    let countryVal = $('.broker-org-country').find(":selected").val();
    
    if (countryVal == "1" || countryVal == "2") {
      $('.broker-org-stateText-wrapper').hide();
      $('.broker-org-state-wrapper').show();
      if (editForm) {
        getRenderedStatesEdit(countryVal, organizations.cmrAddress[0].cadState);
      } else {
        setStatesForBrokerOrg(countryVal);
      }
      $(".broker-org-state-required").text('State/Province/Region *');
      $(".broker-org-state").addClass("required");
      
    } else {
      $('.broker-org-stateText-wrapper').show();
      $('.broker-org-state-wrapper').hide();
      $(".broker-org-state-required").text('State/Province/Region');
      $(".broker-org-state").removeClass("required"); 
    }

    let validateAddressForCountry=false;
    $(validationReqdCountries).each(function() {
     if(this.cdmMeaning.toString() === countryVal.toString()) {
       validateAddressForCountry = true;
       return false;
     } 
     });
     if(validateAddressForCountry){
      $(".country_not_supported").hide();        
    }else{
      $(".country_not_supported").show();
    }

    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conId.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });
    if(checkZipCode){
      $(".broker-org-zipcode-required").text('Postal Code *');  
      $(".broker-org-zipcode").addClass("required");   
    } else{
      $(".broker-org-zipcode-required").text('Postal Code');
      $(".broker-org-zipcode").removeClass("required");
    } 

  }

  function setStatesForBrokerOrg(countryVal) {
    // re-initialize states dropdown on every call
    $('.broker-org-state').html('');
    if (countryVal == "1") {
      setOptionsForSelect({
        selectElement: $('.broker-org-state'),
        list: usaStates,
        valueDataKey: "cdmValue",
        textDataKey: "cdmMeaning"
      });
    } else if (countryVal == "2") {
      setOptionsForSelect({
        selectElement: $('.broker-org-state'),
        list: caProvinces,
        valueDataKey: "cdmValue",
        textDataKey: "cdmMeaning"
      });
    }
  }

  function getRenderedStatesEdit(countryVal, selectedState) {
    $('.broker-org-state').html('');
    const brokerStateOptionHtml = '<option value="{%- state.cdmValue %}" {%- selected %} >{%- state.cdmMeaning %}</option>';
    let response = "";
    if (countryVal == "1") {
      response = _.map(usaStates, (usaState) => {
        return render(brokerStateOptionHtml, {
          state: usaState,
          selected: (selectedState == usaState.cdmValue) ? "selected" : ""
        });
      });
    } else if (countryVal == "2") {
      response = _.map(caProvinces, (caProvince) => {
        return render(brokerStateOptionHtml, {
          state: caProvince,
          selected: (selectedState == caProvince.cdmValue) ? "selected" : ""
        });
      });
    }
    $('.broker-org-state').append(response.join(""));
  }

  function clearSearchScacHandler(e) {
    e.preventDefault();
    if (elsPage.orgType.val() == 'Carrier') {
      elsPage.carrierScacTypeAhead.text('');
      elsPage.carrierDetailsDiv.addClass('hidden');
      elsPage.carrierInfoButton.addClass('hidden');
      elsPage.useFoundCarrierBtn.removeAttr('disabled');
      elsPage.createCarrierBtn.removeAttr('disabled');
      elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
      // $('.carrier-section-details').hide();
      teamMemberObj = {};
      teamMemberArray = [];
      //  $('#carrier-section-div').hide();
      //  $('#carrier-new-section-div').hide();
      //  $('.team-member-section-details').hide();
      // $('.organizationForm').resetForm();
      $('#carrier-section-div').remove();
      $('#carrier-new-section-div').remove();
      $('.team-member-section-details').remove();
      //$('.organizationForm').find$('#carrier-section-div').hide();
    }

  }

  function newCreateCarrierHandler(btnClicked) {
    $('#carrier-section-div').remove();
    $('#carrier-new-section-div').remove();

    const searchNewCarrierByScacHtml = $(render(newCarrierWrapperTemplate, {
      countries: getRenderedCountries(countries),
      phoneCodes: getRenderedPhoneCodes(phoneCodes),
      dupPrgName: duplicateCarrerOrgNameMessage,
      dupAddress: duplicateAddressMessage,
    }));

    elsPage.carrierSection.append(searchNewCarrierByScacHtml);
    handleSwitchingCarrierStateInput();
    instantiateSelect2(searchNewCarrierByScacHtml.find('.select2-select'));
    
    //Handle the change events in the form 
    searchNewCarrierByScacHtml.find(".new-carrier-by-scac-country").on("change", handleSwitchingCarrierStateInput);
    searchNewCarrierByScacHtml.find('.carrier-phone-code').on("change", handleSwitchingCarrierPhoneCountry);
    handleSwitchingCarrierPhoneCountry();
  }

  function handleSwitchingCarrierPhoneCountry() {
    let carrierPhoneCode=$(".carrier-phone-code");
    let newPhoneFormat=$('.new-phone-format');
    if (carrierPhoneCode.val() === "+1") {
      newPhoneFormat.addClass("phoneUS");
      newPhoneFormat.removeClass("phoneNonUS");
      newPhoneFormat.attr("placeholder", "___-____");
      newPhoneFormat.inputmask("(999) 999-9999");
    } else {
      newPhoneFormat.addClass("phoneNonUS");
      newPhoneFormat.removeClass("phoneUS");
      newPhoneFormat.removeAttr('placeholder'); 
      newPhoneFormat.inputmask("");
      let val= newPhoneFormat.val();						
      if(val){
        const v=val.replace(/[^0-9.]/g, "");
        newPhoneFormat.val(v);
      }

    }

  }

  function handleSwitchingCarrierStateInput() {
    let countryVal = $('.new-carrier-by-scac-country').find(":selected").val();
    if (countryVal == "1" || countryVal == "2") {
      $('.new-carrier-by-scac-stateText-wrapper').hide();
      $('.new-carrier-by-scac-state-wrapper').show();
      $(".new-carrier-by-scac-state-required").text('State/Province/Region *');
      $(".new-carrier-by-scac-state").addClass("required");
      setStates(countryVal);
    } else {
      $('.new-carrier-by-scac-stateText-wrapper').show();
      $('.new-carrier-by-scac-state-wrapper').hide();
      $(".new-carrier-by-scac-state-required").text('State/Province/Region');
      $(".new-carrier-by-scac-state").removeClass("required");
      $(".new-carrier-by-scac-stateText").removeClass("required");      
    }

    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conId.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });
    
    if(checkZipCode){
      $(".new-carrier-contact-postalcode-required").text('Postal Code *');  
      $(".new-carrier-contact-postalcode").addClass("required");   
    } else{
      $(".new-carrier-contact-postalcode-required").text('Postal Code');
      $(".new-carrier-contact-postalcode").removeClass("required");
    } 

    let validateAddressForCountry=false;
    $(validationReqdCountries).each(function() {
     if(this.cdmMeaning.toString() === countryVal.toString()) {
       validateAddressForCountry = true;
       return false;
     } 
     });

     if(validateAddressForCountry){
      $(".new-carrier-by-scac-country-not-supported").hide();        
    }else{
      $(".new-carrier-by-scac-country-not-supported").show();
    }
  }

  function setStates(countryVal) {
    // re-initialize states dropdown on every call
    $('.new-carrier-by-scac-state').html('');
    if (countryVal == "1") {
      setOptionsForSelect({
        selectElement: $('.new-carrier-by-scac-state'),
        list: usaStates,
        valueDataKey: "cdmValue",
        textDataKey: "cdmMeaning"
      });
    } else if (countryVal == "2") {
      setOptionsForSelect({
        selectElement: $('.new-carrier-by-scac-state'),
        list: caProvinces,
        valueDataKey: "cdmValue",
        textDataKey: "cdmMeaning"
      });
    }
  }


  function newCarrierHandler(carData, btnClicked) {

    $('#carrier-section-div').remove();
    $('#carrier-new-section-div').remove();

    const searchCarrierByScacHtml = $(render(searchCarrierByScacWrapperTemplate, {

      carName: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carName) ? "" : carData[0].carName,
      carScac: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carScac) ? "" : carData[0].carScac,
      carGln: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carGln) ? "" : carData[0].carGln,
      carContactName: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carContactName) ? "" : carData[0].carContactName,
      carPhoneCountryCode: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carPhoneCountryCode) ? "" : carData[0].carPhoneCountryCode,
      carContactPhone: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].carContactPhone) ? "" : carData[0].carContactPhone,

      cadContactEmail: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadContactEmail) ? "" : carData[0].cmrAddress.cadContactEmail,
      cadCountry: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadCountry) ? "" : carData[0].cmrAddress.cadCountry,
      cadAddress1: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadAddress1) ? "" : carData[0].cmrAddress.cadAddress1,
      cadAddress2: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadAddress2) ? "" : carData[0].cmrAddress.cadAddress2,
      cadCity: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadCity) ? "" : carData[0].cmrAddress.cadCity,
      cadState: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadState) ? "" : carData[0].cmrAddress.cadState,
      cadZipcode: isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadZipcode) ? "" : carData[0].cmrAddress.cadZipcode,
      countries: getRenderedCountriesforCarr(countries),
      phoneCodes: getRenderedPhoneCodes(phoneCodes)

    }));


    instantiateSelect2(searchCarrierByScacHtml.find('.select2-select'));

    let phoneCodeIdSelected = "";
    if (carData[0] != null && carData[0].carPhoneCountryCode != null) {
      phoneCodeIdSelected = carData[0].carPhoneCountryCode;
    }

    let stateCodeIdSelected = "";
    if (carData[0] != null && carData[0].cmrAddress.cadState != null) {
      stateCodeIdSelected = carData[0].cmrAddress.cadState;
    }

    let countryCodeIdSelected = "";
    if (carData[0] != null && carData[0].cmrAddress.cadCountry != null) {
      countryCodeIdSelected = carData[0].cmrAddress.cadCountry;
    }

    searchCarrierByScacHtml.find('.carrier-by-scac-state').val(stateCodeIdSelected).trigger('change');
    searchCarrierByScacHtml.find(".carrier-phone-code").val(phoneCodeIdSelected).trigger('change');

      $(".carrier-section-details :input").attr("disabled", 'disabled');

    searchCarrierByScacHtml.find(".carrier-by-scac-country").on("change", handleCarCountryChange);
    searchCarrierByScacHtml.find('.phoneUS').inputmask({ mask: "(999) 999-9999" });
    elsPage.carrierSection.append(searchCarrierByScacHtml);



  }
  function getRenderedCountriesforCarr(countries) {
    const optionHtml = '<option value="{%- country.conCode %}">{%- country.conName %}</option>';
    const response = _.map(countries, (country) => {
      return render(optionHtml, {
        country: country
      });
    });

    return response.join("");
  }

  function handleCarCountryChange() {
    handleSwitchingStateInputForCarrier();
  }

  function handleSwitchingStateInputForCarrier() {
    const formEl = $('#carrier-contact-info');
    instantiateSelect2(formEl.find('.select2-select'));
    let countryVal = formEl.find('.carrier-by-scac-country').val();
    if (isNullOrUndefined(countryVal)) {
      //  countryVal = carData[0].cmrAddress.cadCountry;
      countryVal = isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadCountry) ? "" : carData[0].cmrAddress.cadCountry;
    }
    if (countryVal == "US" || countryVal == "CA") {
      formEl.find(".carrier-by-scac-stateText-wrapper").hide();
      formEl.find(".carrier-by-scac-state-wrapper").show();
      $(".carrier-by-scac-state-required").text('State/Province/Region *');
      $("carrier-by-scac-state").addClass("required");
      $("carrier-by-scac-stateText").addClass("required");
      getRenderedStatesorProvinceForCarr(countryVal, isNullOrUndefined(carData[0]) ? "" : isNullOrUndefined(carData[0].cmrAddress) ? "" : isNullOrUndefined(carData[0].cmrAddress.cadState) ? "" : carData[0].cmrAddress.cadState);
    } else {
      formEl.find(".carrier-by-scac-stateText-wrapper").show();
      formEl.find(".carrier-by-scac-state-wrapper").hide();
      $(".carrier-by-scac-state-required").text('State/Province/Region');
      $(".carrier-by-scac-state").removeClass("required");
      $(".carrier-by-scac-stateText").removeClass("required");
    }
    

    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });
    if(checkZipCode){
      $(".carrier-contact-postalcode-required").text('Postal Code *');  
      $(".carrier-contact-postalcode").addClass("required");   
    } else{
      $(".carrier-contact-postalcode-required").text('Postal Code');
      $(".carrier-contact-postalcode").removeClass("required");
    } 



    let validateAddressForCountry=false;
    $(validationReqdCountries).each(function() {
     if(this.cdmValue.toString() === countryVal.toString()) {
       validateAddressForCountry = true;
       return false;
     } 
     });
     if(validateAddressForCountry){
      $(".carrier-by-scac-country-required").hide();        
    }else{
      $(".carrier-by-scac-country-required").show();
    }

    let phoneCodeVal = formEl.find('.carrier-phone-code').val();
    let carrierPhoneNumber = $('.carrier-phone-number');
    if (phoneCodeVal === "+1") {
      carrierPhoneNumber.addClass("phoneUS");
      carrierPhoneNumber.removeClass("phoneNonUS");
      carrierPhoneNumber.attr("placeholder", "___-____");
      carrierPhoneNumber.inputmask("(999) 999-9999");
      
    } else {
      carrierPhoneNumber.addClass("phoneNonUS");
      carrierPhoneNumber.removeClass("phoneUS");
      carrierPhoneNumber.removeAttr('placeholder'); 
      carrierPhoneNumber.inputmask("");
      let val= carrierPhoneNumber.val();						
      if(val){
        const v=val.replace(/[^0-9.]/g, "");
        carrierPhoneNumber.val(v);
      }
    }

   

  }

  function getRenderedStatesorProvinceForCarr(countryVal, selectedState) {
    $('.carrier-by-scac-state').html('');
    const carrierStateOptionHtml = '<option value="{%- state.cdmValue %}" {%- selected %} >{%- state.cdmMeaning %}</option>';
    let response = "";
    if (countryVal == "US") {
      response = _.map(usaStates, (usaState) => {
        return render(carrierStateOptionHtml, {
          state: usaState,
          selected: (selectedState == usaState.cdmValue) ? "selected" : ""
        });
      });
    } else if (countryVal == "CA") {
      response = _.map(caProvinces, (caProvince) => {
        return render(carrierStateOptionHtml, {
          state: caProvince,
          selected: (selectedState == caProvince.cdmValue) ? "selected" : ""
        });
      });
    }
    $('.carrier-by-scac-state').append(response.join(""));
  }

  function newCarrierTeamMemberDetailsHandler() {

    //$('.team-member-section-details').show();
    const orgCarrierTeamFormHtml = $(render(carrierTeamMemberDetailsWrapperTemplate,
      {
        orgType: "carrier"
      }));
    if (editForm) {
      $('.carrierFormEdit').append(orgCarrierTeamFormHtml);
    } else {
      elsPage.carrierSection.append(orgCarrierTeamFormHtml);
    }
    $('.team-broker-section').hide();
  }

  function newTeamMemberAddHandler() {
    $("#org-facility-form").hide();
    let arrayIndex = teamMemberArray.length;
    if(removeArryIndex == 0){
       arrayIndex = teamMemberArray.length;
    }else{
        arrayIndex = removeArryIndex+1;
    }
    if (elsPage.orgType.val() == 'Transportation Broker') {
      const orgAddCarrierTeamMemberHtml = $(render(addCarrierTeamMemberWrapperTemplate,
        {
          newEdit: "New",
          phoneCodes: getRenderedPhoneCodes(phoneCodes),
          orgName: elsPage.brokerSection.find('[name=broker-org-name]').val(),
          orgType: "broker",
          arrayIndex
        }))
      orgAddCarrierTeamMemberHtml.find('.phoneUS').inputmask({
        mask: "(999) 999-9999"
      });
      instantiateSelect2(orgAddCarrierTeamMemberHtml.find('.select2-select'));
      $('.organizationForm').append(orgAddCarrierTeamMemberHtml);
    } else {
      const orgAddCarrierTeamMemberHtml = $(render(addCarrierTeamMemberWrapperTemplate,
        {
          newEdit: "New",
          phoneCodes: getRenderedPhoneCodes(phoneCodes),
          orgName:elsPage.carrierSection.find('[name=carrier-section-org-name]').val()?elsPage.carrierSection.find('[name=carrier-section-org-name]').val():elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val(),
          orgType: "carrier",
          arrayIndex
        }))
      orgAddCarrierTeamMemberHtml.find('.phoneUS').inputmask({
        mask: "(999) 999-9999"
      });
      instantiateSelect2(orgAddCarrierTeamMemberHtml.find('.select2-select'));
      $('.organizationForm').append(orgAddCarrierTeamMemberHtml);
    }
  }


  var checkUserName = function () {
    let arrayIndex = '';
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      //new flow
      arrayIndex = teamMemberArray.length;
    }
    else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
    }
    $("#user-name-exist-error-" + arrayIndex).hide();
    var inputValue = $("#car-team-member-username-" + arrayIndex).val();
    checkDuplicateUserDetails('UserName', inputValue, arrayIndex);
    checkDuplicateUserTeamMember('UserName', teamMemberArray, inputValue, arrayIndex);
  }
  var checkEmailId = function () {
    let arrayIndex = '';
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      //new flow
      arrayIndex = teamMemberArray.length;
    }
    else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
    }
    var inputValue = $("#car-team-member-email-" + arrayIndex).val();
    $("#user-email-exist-error-" + arrayIndex).hide();
    checkDuplicateUserDetails('EmailId', inputValue, arrayIndex);
    checkDuplicateUserTeamMember('EmailId', teamMemberArray, inputValue, arrayIndex);
  }

  //check duplicate teamMember in array
  function checkDuplicateUserTeamMember(inputType, teamMemberArray, inputValue, arrayIndex) {
    for (var i = 0; i < teamMemberArray.length; i++) {
      if (inputType == 'UserName') {
        if (teamMemberArray[i].userName == inputValue) {
          $("#user-name-exist-error-" + arrayIndex).show();
        }
      } else if (inputType == 'EmailId') {
        if (teamMemberArray[i].email == inputValue) {
          $("#user-email-exist-error-" + arrayIndex).show();
        }
      }
    }
  }

  //Check duplicate user name
  var checkDuplicateUserDetails = function (inputType, inputValue, arrayIndex) {
    if (inputType.length > 0 && inputValue.length > 0) {
      $.ajax(
        {
          url: checkUserNameValidation,
          type: "GET",
          data: { inputValue: inputValue, inputType: inputType },
          beforeSend: function () {
            $.blockUI({ message: 'Checking User Name, Please Wait..' });
          },
          complete: function () {
            $.unblockUI();
          },
          success: function (data) {
            if (data.trim() == 'true') {
              if (inputType == 'UserName') {
                $("#user-name-exist-error-" + arrayIndex).show();
              } else if (inputType == 'EmailId') {
                $("#user-email-exist-error-" + arrayIndex).show();
              }

            }

          }
        });
    }
  }

  function setTeamMembersForEdit(orgTypeVal) {
    _(teamMemberDetailsForEdit).map((teammember) => {
      let arrayIndex = teamMemberArray.length;
      const orgAddBrokerTeamMemberForEditHtml = $(render(
        addCarrierTeamMemberWrapperTemplate, {
          newEdit: "Edit",
          phoneCodes: (orgTypeVal == 'broker') ? getRenderedPhoneCodesEdit(phoneCodes, organizations.cmrAddress[0].cadContactCountryPhoneCode) : getRenderedPhoneCodes(phoneCodes),
          orgName: (orgTypeVal == 'broker') ? elsPage.brokerSection.find('[name=broker-org-name]').val() : elsPage.carrierSection.find('[name=carrier-section-org-name]').val(),
          orgType: orgTypeVal,
          userId: teammember.userId,
          firstName: teammember.firstName,
          lastName: teammember.lastName,
          emailAddress: teammember.emailAddress,
          userName: teammember.userName,
          phoneNumber: teammember.phoneNumber,
          phoneCode: teammember.phoneCode,
          title: teammember.organizationTitle,
          arrayIndex
          //activateUser: teammember.status==0? "q-display-none": "",
          //inactivateUser: teammember.status==0? "": "q-display-none"
        }));
      $('.organizationForm').append(orgAddBrokerTeamMemberForEditHtml);
      orgAddBrokerTeamMemberForEditHtml.find("#car-team-member-phone-code-"+arrayIndex).val(teammember.phoneCode).trigger('change');
      $('#addCarrierTeamMemberDivSec-' + arrayIndex).hide();
      const brokerTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
      teamMemberArray.push(teamMemberObj);
      if (orgTypeVal == 'broker') {
        $('#access-to-team-members-broker').append(brokerTeamMemberDetails);
      } else {
        $('#access-to-team-members-carrier').append(brokerTeamMemberDetails);

      }
    });
  }

  function setAffiliatedCarrierOrgsForEdit() {
    _(affiliatedCarrierOrgs).map((carrierOrg) => {
      $("#find-carriers-for-broker option[value='" + carrierOrg.orgId + "']").attr("selected", 1);
    });
  }

  function handleCarrierPhoneCodeTeamMember(e){
    let carrierPhoneCodeTeamMemberCode=$('.organizationForm').find('.carrier-phone-code-add-carrier-team-member');    
    let carrierPhoneNumberTeamMember=$('.organizationForm').find('.carrier-phone-number-add-carrier-team-member');
    let val= carrierPhoneNumberTeamMember.val();
    if (carrierPhoneCodeTeamMemberCode.val() === "+1") {     
     
     let v=val.replace(/[^0-9.]/g, "");
     if(v.length>10){ 
        v=val.substring(0,10);
        carrierPhoneNumberTeamMember.val(v);
      }  
     carrierPhoneNumberTeamMember.addClass("phoneUS");
     carrierPhoneNumberTeamMember.removeClass("phoneNonUS");
     carrierPhoneNumberTeamMember.attr("placeholder", "___-____");
     carrierPhoneNumberTeamMember.inputmask("(999) 999-9999");
      
    } else {
      carrierPhoneNumberTeamMember.addClass("phoneNonUS");
      carrierPhoneNumberTeamMember.removeClass("phoneUS");
      carrierPhoneNumberTeamMember.removeAttr('placeholder'); 
      carrierPhoneNumberTeamMember.inputmask("");
      if(val){
       const v=val.replace(/[^0-9.]/g, "");
       carrierPhoneNumberTeamMember.val(v);
      }
    }
  }

  function saveTeamMemberBtnHandler(e) {
    e.preventDefault();
    let arrayIndex = '';
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      //new flow
      arrayIndex = teamMemberArray.length;
    }
    else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
    }

    const isMainFormValid = mainEl.find(".organizationForm").valid();
    if (!$("#user-name-exist-error-" + arrayIndex).is(":visible")
      && !$("#user-email-exist-error-" + arrayIndex).is(":visible")) {
      if (isMainFormValid) {
        showTeamMemberSaveModal();
      }
    }
  }

  function showTeamMemberSaveModal() {
    saveTeamMemberModel.modal('show');
  }

  function loadCarrierDetailsHandler() {
    let arrayIndex = '';
    saveTeamMemberModel.modal('hide');
    addTeamMemberDetails();
    $('.carrier-teamMember-section').hide();
    orgFacilityForm.show();
    $('.remove-check-' + (removeArryIndex)).removeClass('disabled');
     }

  function cancelTeamMemberBtnHandler() {
    $('.carrier-teamMember-section').hide();
    orgFacilityForm.show();
  }

  let teamMemberObj = {};
  let removeArryIndex = 0;
  function addTeamMemberDetails() {
    let arrayIndex = "";
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      // new flow
      arrayIndex = teamMemberArray.length;
      if(removeArryIndex == 0){
            arrayIndex = teamMemberArray.length;
      }else{
          arrayIndex = removeArryIndex+1;
      }
      const carrierTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
      teamMemberArray.push(teamMemberObj);
      if (elsPage.orgType.val() == 'Transportation Broker') {
        $('#access-to-team-members-broker').append(carrierTeamMemberDetails);
      } else {
        $('#access-to-team-members-carrier').append(carrierTeamMemberDetails);
      }

    } else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
      const carrierTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
      $('#team-member-edit-' + arrayIndex).html(carrierTeamMemberDetails);
      teamMemberObj = {};
    }
    removeArryIndex = arrayIndex;
  }

  function setTeamMemberDetailsHtml(arrayIndex) {
    teamMemberObj.userName = $('#car-team-member-username-' + arrayIndex).val();
    teamMemberObj.firstName = $("#car-team-member-first-name-" + arrayIndex).val();
    teamMemberObj.lastName = $("#car-team-member-last-name-" + arrayIndex).val();
    teamMemberObj.title = $("#org-title-" + arrayIndex).val();
    teamMemberObj.email = $("#car-team-member-email-" + arrayIndex).val();
    teamMemberObj.phoneCode = $("#car-team-member-phone-code-" + arrayIndex).val();
    teamMemberObj.phone = $("#car-team-member-phone-" + arrayIndex).val();

   

    const carrierTeamMemberDetails = $(render(addCarrierTeamMemberDetailsWrapperTemplate, {
      userName: teamMemberObj.userName,
      title: teamMemberObj.title,
      email: teamMemberObj.email,
      phoneCode: teamMemberObj.phoneCode,
      phone: teamMemberObj.phone,
      firstName: teamMemberObj.firstName,
      lastName: teamMemberObj.lastName,
      arrayIndex
    }));
  

    return carrierTeamMemberDetails;
  }


  function editTeamMemberBtn(e) {
    e.preventDefault();
    $("#org-facility-form").hide();
    let indexId = $(this).closest('.edit-team-member-btn').data('index-id');
    removeArryIndex = indexId;
    // just show the team member for which you want to edit
    for (let i = 0; i <= removeArryIndex; i++) {
      if (i == indexId) {
        $('#addCarrierTeamMemberDivSec-' + i).show();
        $("#car-team-member-username-" + i).attr("disabled", "disabled");
        teamMemberObj = {};
        teamMemberObj.editIndexId = i;
      } else {
        $('#addCarrierTeamMemberDivSec-' + i).hide();
      }
    }
    handleCarrierPhoneCodeTeamMember();
  }

  function removeTeamMemberBtn(e) {
    e.preventDefault();
    let arrayIndex="";
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      //new flow
      arrayIndex = teamMemberArray.length;
    } else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
    }
    let indexId = $(this).closest('.remove-team-member-btn').data('index-id');
    $('.team-check-' + indexId).remove();
    for (let i = 0; i < teamMemberArray.length; i++) {
      if (i == indexId) {
        teamMemberArray.pop(i);
        $('#addCarrierTeamMemberDivSec-' + (i)).remove();
      }
    }
  }



  //Validate the Form 
  function validateForm(formElement) {
    if (formElement.valid() && !formElement.find('.dup-facName').is(':visible') && !formElement.find('.dup-facId').is(':visible')) {
      return true;
    } else {
      return false;
    }
  }

  //Validate the Address section 
  function validateAddressModal(formElement) {
    const addressSectionMap = {
      //Address fields
      addFacilityCountrySelect: '.facility-country',
      facilityAddress1: '.facility-address1',
      facilityAddress2: '.facility-address2',
      facilityCity: '.facility-city',
      facilityZipCode: '.facility-zip',
      facilityStateDropDown: '.facility-state',
      facilityStateText: '.facility-stateText'
    };
    setElementsFromScope(elsPage, addressSectionMap, formElement);
    let state = '';

    let validateAddressForCountry=false;
    $(validationReqdCountries).each(function() {
   if(this.cdmMeaning.toString() === elsPage.addFacilityCountrySelect.val()||this.cdmValue.toString() === elsPage.addFacilityCountrySelect.val()) {
     validateAddressForCountry = true;
     return false;
   } 
   });
    if (validateAddressForCountry) {
      state = elsPage.facilityStateDropDown.val();
      $.ajax({
        url: addressValidationUrl,
        type: "POST",
        data: {
          [`${portletNamespace}cadAddress1`]: elsPage.facilityAddress1.val(),
          [`${portletNamespace}cadAddress2`]: elsPage.facilityAddress2.val(),
          [`${portletNamespace}cadCity`]: elsPage.facilityCity.val(),
          [`${portletNamespace}cadState`]: state,
          [`${portletNamespace}cadZipcode`]: elsPage.facilityZipCode.val(),
          [`${portletNamespace}cadCountry`]: elsPage.addFacilityCountrySelect.val()
        },
        beforeSend: function () {
          $.blockUI({ message: 'Validating Address, Please Wait..' });
        },
        complete: function () {
          $.unblockUI();
        },
        success: function (data, textStatus, jqXHR) {
          addValResponse = $.parseJSON(data);
          if (addValResponse.result == true) {
            EditChecker.setPageClean();
            elsPage.addressReturned.css("display", "");
            elsPage.invalidAddress.css("display", "none");
            elsPage.invalidAddressText.css("display", "none");
            elsPage.returnedAddressRadio.prop('checked', false);
            elsPage.enteredAddressRadio.prop('checked', true);
            elsPage.returnedAddressRadio.show();
            checkSubmitAddressForm(addValResponse);
          } else {
            elsPage.addressReturned.css("display", "none");
            elsPage.invalidAddress.css("display", "");
            elsPage.invalidAddressText.css("display", "");
            elsPage.invalidAddressText.html('Unable to find a validated address');
            elsPage.returnedAddressRadio.hide();
            elsPage.returnedAddressRadio.prop('checked', false);
            elsPage.enteredAddressRadio.prop('checked', true);
            checkSubmitAddressForm(addValResponse);
          }
        }
      });
    } else {
      submitFacilityAddress();
    }
  }

  function checkSubmitAddressForm(addValResponse) {
    elsPage.enteredAddressText.html(addValResponse.enteredAdd);
    elsPage.returnedAddressText.html(addValResponse.returnedAdd);
    elsPage.returnedAddressRadio.prop('checked', true);
    addressEl.modal('show');
  }


  //If the user chooses to stay on the static form to modify the address 
  function modifyFacilityAddress() {
    addressEl.modal('hide');
  }


  //User chooses to submit the address whether the entered one or the returned one 
  function submitFacilityAddress(cadId) {
    var cmrCarrierAddressObj = {};

    cmrCarrierAddressObj.cadId = addValResponse.cadId;
    if (elsPage.orgType.val() == 'Carrier') {

      //  if (elsPage.returnedAddressRadio.is(":checked") && doAddressValidation) {
      if (btnClicked === 'create') {
        cmrCarrierAddressObj.cadCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
        let countryVal = $('.new-carrier-by-scac-country').val();   
      } else if (btnClicked === 'found') {
        cmrCarrierAddressObj.cadCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
      } else {
        cmrCarrierAddressObj.cadCountry = orgFacilityForm.find('[name=new-carrier-contact-country]').val();
      }
      cmrCarrierAddressObj.cadState = addValResponse.returnedState;
      cmrCarrierAddressObj.cadAddress1 = addValResponse.returnedAddress1;
      cmrCarrierAddressObj.cadAddress2 = addValResponse.returnedAddress2;
      cmrCarrierAddressObj.cadCity = addValResponse.returnedCity;
      cmrCarrierAddressObj.cadZipcode = addValResponse.returnedZip;
      cmrCarrierAddressObj.cadUseStdAddress = '1';

      // }

      addressEl.modal('hide');
      saveCarrierModalHandler(cmrCarrierAddressObj);
      return;
    }

    const formHTML = "<form id='facility-form-{%-arrayIndex%}' data-obj-id='{%- arrayIndex%}' class='child-form-edit'><div class='q-section custom-expander-parent'>";
    //If active form element has data-org-id store at that index, else push 
    const dataObjId = activeFormElement.data("obj-id");
    let cmrAddressObj = prepareDataForSubmit(activeFormElement);

    if (_.isNumber(dataObjId)) {
      addAddressToStore(cmrAddressObj, dataObjId);
    } else {
      addAddressToStore(cmrAddressObj);
    }


    const arrayIndex = facilityArray.length - 1;
    if (saveBtnClicked) {
      saveModalHandler();
    } else if (activeFormElement.attr("id") != 'master-form') {
      hideEditForm(activeFormElement);
      activeFormElement = $("#master-form");
    } else {
      const orgAddedHtml = $(render(facilityWrapperTemplate,
        {
          masterForm: render(formHTML, {
            arrayIndex,
            ...cmrAddressObj
          }),
          facilityDetails: render(facilityDetailsHtml, {
            arrayIndex,
            ...cmrAddressObj,
            dupFacName: duplicateCadLocationNameMessage,
            dupFacId: duplicateAddressIdMessage,
            rmsTypes: getRMSFacilityTypes(arrayIndex)
          }),
          hcmbFacilityTypes: getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex),
          rmsFacilityTypes: getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex),
          facilityAddress: render(facilityAddressHtml, {
            arrayIndex,
            ...cmrAddressObj,
            countries: getRenderedCountries(countries)
          }),
          facilityContact: render(facilityContactHtml, {
            arrayIndex,
            ...cmrAddressObj,
            phoneCodes: getRenderedPhoneCodes(phoneCodes)

          }),
          facilityName: cmrAddressObj.cadLocationName,
          sectionIsExpandable: render(require("./html/createOrganization/editFormOptions.html")),
          isHoneyComb
        }
      ));
      elsPage.facilityFormDiv.append(orgAddedHtml);
      ///Trigger on the default values
      instantiateSelect2(orgAddedHtml.find('.select2-select'));
      //Mask the Phone number 
      orgAddedHtml.find('.phone-format').inputmask({
        mask: "(999) 999-9999"
      });

      //Handle the change events in the form 
      orgAddedHtml.find(".facility-country").on("change", handleCountryChange);
      orgAddedHtml.find(".facility-country").val(cmrAddressObj.cadCountry).trigger('change');
      if (cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry === "2") {
        orgAddedHtml.find(".facility-state").val(cmrAddressObj.cadState).trigger('change');
      } else {
        orgAddedHtml.find(".facility-stateText").val(cmrAddressObj.cadState);
      }
      if (!isHoneyComb) {
        orgAddedHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
        orgAddedHtml.find(".fedex-acct-num-location").val(cmrAddressObj.cadCmtId).trigger("change");
        orgAddedHtml.find(".retailer-cas-acct").val(cmrAddressObj.cadCcaId).trigger("change");
        const attrArray = cmrAddressObj.cmrAddressAttributes;
        let facType = "";
        for (let i = 0; i < attrArray.length; i++) {
          if (attrArray[i].caaValue === "VR") {
            facType = "vendor";
          }
          else if (attrArray[i].caaValue === "RC") {
            facType = "return";
          }
        }
        if (facType === "vendor") {
          let vrRequired = false;
          for (let i = 0; i < attrArray.length; i++) {
            if (attrArray[i].caaKey === "vendor_ra_required") {
              vrRequired = true;
            }
          }
          if (vrRequired) {
            instantiateSwitchery(orgAddedHtml.find(".ra-auth-switch"), true);
            setSwitchery(orgAddedHtml.find(".ra-auth-switch"), true);
            for (let i = 0; i < attrArray.length; i++) {
              if (attrArray[i].caaKey === "vendor_standing_ra") {
                orgAddedHtml.find(".stndNumber").show();
                orgAddedHtml.find(".stndNumber").val(attrArray[i].caaValue);
              }
            }
          } else {
            instantiateSwitchery(orgAddedHtml.find(".ra-auth-switch"), false);
            setSwitchery(orgAddedHtml.find(".ra-auth-switch"), false);
            orgAddedHtml.find(".stndNumber").hide();
          }
          orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
          orgAddedHtml.find('.inboundClassification').hide();
        } else {
          orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
          orgAddedHtml.find('.inboundClassification').show();
          orgAddedHtml.find('.vendorSelectAuthorization').hide();
        }
      }

      orgAddedHtml.find(".facility-phone-code").val(cmrAddressObj.cadContactCountryPhoneCode).trigger('change');
      hideAllExpandableSectionsOnPageLoad();
      resetMasterForm();
      mainEl.find(elsMap.masterFormSectionParent).show();
    }

  }

  function getRmsFacilityTypes(cmrAddressObj, arrayIndex) {
    if (!isHoneyComb) {
      return render(inboundClassificationHtml, {
        arrayIndex,
        ...cmrAddressObj,
        inboundClassificationTypes: getRenderedInboundTypes(inboundClassificationTypes),
        isHoneyComb
      });
    }
  }

  function prepareDataForSubmit(formElement, doAddressValidation = true) {
    let arrayIndex = formElement.data("obj-id");
    if (_.isUndefined(arrayIndex)) {
      arrayIndex = "";
    }
    //Values of Facility Object that need to be stored 
    const facilityObjMap = {
      facilityName: ".facility-name",
      facilityId: ".facility-id",
      contactName: ".contact-name",
      phoneCode: ".facility-phone-code",
      phoneNumber: ".contact-number",
      emailId: ".contact-email",
      returnCenter: "#return" + arrayIndex,
      manualReturn: "#manual_return" + arrayIndex,
      partnerFacility: "#partner_facility" + arrayIndex,
      facilityType: ".rms-facility-type",
      fedExAccount: ".fedex-acct-num-location",
      rmsCharity: "#CHA" + arrayIndex,
      rmsDestroy: "#DES" + arrayIndex,
      rmsRecall: "#RCL" + arrayIndex,
      rmsRecycle: "#REC" + arrayIndex,
      rmsRefurbish: "#REF" + arrayIndex,
      rmsReturnable: "#RET" + arrayIndex,
      rmsReturnToStock: "#RTS" + arrayIndex,
      rmsSalvage: "#SAL" + arrayIndex,
      addFacilityCountrySelect: ".facility-country",
      facilityStateDropDown: ".facility-state",
      facilityAddress1: ".facility-address1",
      facilityAddress2: ".facility-address2",
      facilityCity: ".facility-city",
      facilityZipCode: ".facility-zip",
      facilityStateText: ".facility-stateText",
      returnAuthReq: ".ra-auth-switch",
      stndNumber: ".stndNumber",
      casAccount: ".retailer-cas-acct"

    };
    setElementsFromScope(elsPage, facilityObjMap, formElement);
    //On Submit address, create the CmrAddressObj and Store the values in it 
    let cmrAddressObj = {};
    let cmrAddressAttributes = [];
    let state = '';
    let cadId = formElement.find(".cadId").val();
    let cadStatus = formElement.find('.cadStatus').val();
    if (elsPage.addFacilityCountrySelect.val() == '1' || elsPage.addFacilityCountrySelect.val() == '2') {
      state = elsPage.facilityStateDropDown.val();
    } else {
      state = elsPage.facilityStateText.val();
    }

    cmrAddressObj.cadId = cadId;
    cmrAddressObj.cadActive = cadStatus;
    //Facility Details
    if (!isHoneyComb) {
      cmrAddressObj.cadAddressType = elsPage.facilityType.val();
      cmrAddressObj.cadCmtId = elsPage.fedExAccount.val();
      cmrAddressObj.cadCcaId = elsPage.casAccount.val();
      if (cmrAddressObj.cadAddressType === 'vendor') {
        let cmrObj = {};
        cmrObj.caaKey = "vendor";
        cmrObj.caaValue = "VR";
        cmrAddressAttributes.push(cmrObj);
        if (elsPage.returnAuthReq.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "vendor_ra_required";
          cmrAttributeobj.caaValue = "true";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.stndNumber.val() != "") {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "vendor_standing_ra";
          cmrAttributeobj.caaValue = elsPage.stndNumber.val();
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
      }

      if (cmrAddressObj.cadAddressType === 'return') {
        let cmrObj = {};
        cmrObj.caaKey = "return";
        cmrObj.caaValue = "RC";
        cmrAddressAttributes.push(cmrObj);
        if (elsPage.rmsCharity.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "CHA";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsDestroy.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "DES";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsRecall.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "RCL";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsRecycle.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "REC";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsRefurbish.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "REF";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsReturnable.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "RET";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsReturnToStock.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "RTS";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        if (elsPage.rmsSalvage.is(":checked")) {
          let cmrAttributeobj = {};
          cmrAttributeobj.caaKey = "inbound_classification";
          cmrAttributeobj.caaValue = "SAL";
          cmrAddressAttributes.push(cmrAttributeobj);
        }
        cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
      }
    }
    else {
      if (elsPage.returnCenter.is(":checked")) {
        let cmrAttributeobj = {};
        cmrAttributeobj.caaKey = "return";
        cmrAttributeobj.caaValue = "RC";
        cmrAddressAttributes.push(cmrAttributeobj);
      }
      if (elsPage.manualReturn.is(":checked")) {
        let cmrAttributeobj = {};
        cmrAttributeobj.caaKey = "manual_return";
        cmrAttributeobj.caaValue = "MR";
        cmrAddressAttributes.push(cmrAttributeobj);
      }
      if (elsPage.partnerFacility.is(":checked")) {
        let cmrAttributeobj = {};
        cmrAttributeobj.caaKey = "partner_facility";
        cmrAttributeobj.caaValue = "PF";
        cmrAddressAttributes.push(cmrAttributeobj);
      }

      cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
    }
    //Set the common fields on the static form to the cmrAddressObj 
    // cmrAddressObj.cadLocationName = elsPage.facilityName.val();
    cmrAddressObj.cadLocationName = elsPage.facilityName.val();
    cmrAddressObj.cadAddressId = elsPage.facilityId.val();
    cmrAddressObj.cadContactName = elsPage.contactName.val();
    cmrAddressObj.cadContactEmail = elsPage.emailId.val();
    cmrAddressObj.cadContactCountryPhoneCode = elsPage.phoneCode.val();
    cmrAddressObj.cadContactPhone = elsPage.phoneNumber.val();
    cmrAddressObj.cadCommercialAddrFlag = addValResponse.returnedIsCommercial;
    cmrAddressObj.cadState = state;

    //If the user selects the Return address populate the Address validation response to the CMRObject 
    //Else If the user selects the Entered address populate the same values as mentioned in the Address section 
    if (elsPage.returnedAddressRadio.is(":checked") && doAddressValidation) {
      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
      cmrAddressObj.cadState = addValResponse.returnedState;
      cmrAddressObj.cadAddress1 = addValResponse.returnedAddress1;
      cmrAddressObj.cadAddress2 = addValResponse.returnedAddress2;
      cmrAddressObj.cadCity = addValResponse.returnedCity;
      cmrAddressObj.cadZipcode = addValResponse.returnedZip;
      cmrAddressObj.cadUseStdAddress = '1';
    }
    else {
      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
      cmrAddressObj.cadAddress1 = elsPage.facilityAddress1.val();
      cmrAddressObj.cadAddress2 = elsPage.facilityAddress2.val();
      cmrAddressObj.cadCity = elsPage.facilityCity.val();
      cmrAddressObj.cadZipcode = elsPage.facilityZipCode.val();
      cmrAddressObj.cadUseStdAddress = '0';
    }
    addressEl.modal('hide');

    return cmrAddressObj;
  }

  function addAddressToStore(cmrAddressObj, index) {
    if (_.isNumber(index)) {
      facilityArray[index] = cmrAddressObj;
    } else {
      facilityArray.push(cmrAddressObj);
    }
  }

  function populateEditForm(cmrAddressObj, arrayIndex) {
    const formHTML = "<form id='facility-form-{%-arrayIndex%}' data-obj-id='{%- arrayIndex%}' class='child-form-edit'><div class='q-section custom-expander-parent'>";

    const orgAddedHtml = $(render(facilityWrapperTemplate,
      {

        masterForm: render(formHTML, {
          arrayIndex
        }),
        ...cmrAddressObj,
        facilityDetails: render(facilityDetailsHtml, {
          arrayIndex,
          ...cmrAddressObj,
          isHoneyComb,
          cadAddressId: cmrAddressObj.cadAddressId,
          dupFacName: duplicateCadLocationNameMessage,
          dupFacId: duplicateAddressIdMessage,
          rmsTypes: getRMSFacilityTypes(arrayIndex)
        }),
        hcmbFacilityTypes: getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex),
        rmsFacilityTypes: getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex),
        facilityAddress: render(facilityAddressHtml, {
          arrayIndex,
          ...cmrAddressObj,
          countries: getRenderedCountries(countries)
        }),
        facilityContact: render(facilityContactHtml, {
          arrayIndex,
          ...cmrAddressObj,
          phoneCodes: getRenderedPhoneCodesEdit(phoneCodes, cmrAddressObj.cadContactCountryPhoneCode)

        }),
        facilityName: cmrAddressObj.cadLocationName,
        sectionIsExpandable: render(require("./html/createOrganization/editFormOptions.html")),
        isHoneyComb
      }
    ));

    elsPage.facilityFormDiv.append(orgAddedHtml);
    //Mask the Phone number 
    orgAddedHtml.find('.phone-format').inputmask({mask: "(999) 999-9999"});
    orgAddedHtml.find('.inboundClassification').hide();
    orgAddedHtml.find(".facility-country").on("change", handleCountryChange);
    orgAddedHtml.find(".facility-country").val(cmrAddressObj.cadCountry).trigger('change');
    if (cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry === "2") {
      orgAddedHtml.find(".facility-state").val(cmrAddressObj.cadState).trigger('change');
    } else {
      orgAddedHtml.find(".facility-stateText").val(cmrAddressObj.cadState);
    }

    
    hideAllExpandableSectionsOnPageLoad();
    if (!isHoneyComb) {
      orgAddedHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
      orgAddedHtml.find(".fedex-acct-num-location").val(cmrAddressObj.cadCmtId).trigger("change");
      orgAddedHtml.find(".retailer-cas-acct").val(cmrAddressObj.cadCcaId).trigger("change");
      const attrArray = cmrAddressObj.cmrAddressAttributes;
      let facType = "";
      for (let i = 0; i < attrArray.length; i++) {
        if (attrArray[i].caaValue === "VR") {
          facType = "vendor";
        }
        else if (attrArray[i].caaValue === "RC") {
          facType = "return";
        }
      }
      if (facType === "vendor") {
        let vrRequired = false;
        for (let i = 0; i < attrArray.length; i++) {
          if (attrArray[i].caaKey === "vendor_ra_required") {
            vrRequired = true;
          }
        }
        if (vrRequired) {
          orgAddedHtml.find("#return-auth-req" + arrayIndex).prop('checked', true);
          for (let i = 0; i < attrArray.length; i++) {
            if (attrArray[i].caaKey === "vendor_standing_ra") {
              orgAddedHtml.find("#stndNumber" + arrayIndex).show();
              orgAddedHtml.find("#stndNumber" + arrayIndex).val(attrArray[i].caaValue);
            }
          }
        }
        orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
        orgAddedHtml.find('.inboundClassification').hide();
      } else {
        orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
        orgAddedHtml.find('.inboundClassification').show();
        orgAddedHtml.find('.vendorSelectAuthorization').hide();
      }
    }
  
  }


  function getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex) {
    if (!isHoneyComb) {
      return render(inboundClassificationHtml, {
        arrayIndex,
        ...cmrAddressObj,
        inboundClassificationTypes: getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressObj.cmrAddressAttributes, cmrAddressObj.cadCity, arrayIndex),
        isHoneyComb
      });
    }
  }

  function getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex) {
    if (isHoneyComb) {
      return render(facilityTypeHtml, {
        arrayIndex,
        ...cmrAddressObj,
        facilityTypes: getRenderedFacilityTypesEdit(facilityTypes, cmrAddressObj.cmrAddressAttributes, cmrAddressObj.cadCity, arrayIndex)
      });
    }
  }

  function populateEdit() {
    for (let i = 0; i < facilityArray.length; i++) {
      populateEditForm(facilityArray[i], i);
      let phoneCode= $('#phone-code'+i);
      phoneCode.val(facilityArray[i].cadContactCountryPhoneCode).trigger('change');
      phoneCode.change({index: i},  function(event) {
        handleFacilityPhoneValidationByIndex(event.data.index);
      });
    }
  }

  function resetMasterForm() {
    editFlag = false;

    const masterForm = mainEl.find("#master-form");
    masterForm[0].reset();
    masterForm.validate().resetForm();
    //Select 2 needs to be handled here 
    masterForm.find('.select2-select').val('');
    instantiateSelect2(masterForm.find('.select2-select'));
    //Handle the change events in the form 
    masterForm.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
    masterForm.find(".rms-facility-type").val("").trigger('change');
    masterForm.find(".facility-country").on("change", handleCountryChange);
    masterForm.find(".facility-country").val(defaultCountry).trigger('change');
    masterForm.find(".facility-phone-code").val("+1").trigger('change');
    activeFormElement = masterForm;

  }

  function getRenderedFacilityTypesEdit(facilityTypes, cmrAddressAttributes, cadCity, arrayIndex) {
    const facilityTypeHtml = require("./html/createOrganization/facilityType.html");
    const response = _.map(facilityTypes, (facility) => {
      return render(facilityTypeHtml, {
        arrayIndex,
        facility: facility,
        cadCity: cadCity,
        isChecked: getValuesForTypes(cmrAddressAttributes, facility)
      });
    });
    return response.join("");
  }

  function getValuesForTypes(cmrAddressAttributes, facility) {
    let checked = "";
    for (let i = 0; i < cmrAddressAttributes.length; i++) {
      if (facility.cdmMeaning === cmrAddressAttributes[i].caaKey) {
        checked = "checked";
      }
    }
    return checked;
  }

  function getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressAttributes, cadCity, arrayIndex) {
    const inboundClassificationHtml = require("./html/createOrganization/inboundClassification.html");
    const response = _.map(inboundClassificationTypes, (inboundClassificationItem) => {
      return render(inboundClassificationHtml, {
        arrayIndex,
        inboundClassificationItem: inboundClassificationItem,
        cadCity: cadCity,
        isChecked: getValuesForInbound(cmrAddressAttributes, inboundClassificationItem)
      });
    });

    return response.join("");
  }

  function getValuesForInbound(cmrAddressAttributes, inbound) {
    let checked = "";
    for (let i = 0; i < cmrAddressAttributes.length; i++) {
      if (inbound.cdmValue === cmrAddressAttributes[i].caaValue) {
        checked = "checked";
      }
    }
    return checked;
  }

  function getRenderedPhoneCodesEdit(phoneCodes, selectedCode) {
    const phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}" {%- selected %} >{%- phoneCode.conPhoneText %}</option>';
    let count = 0;
    const response = _.map(phoneCodes, (phoneCode) => {
      if (phoneCode.conPhoneCode === '+1' && count == 0) {
        phoneCode.conPhoneText = "United States of America/Canada +1";
        count++;
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode,
          selected: getselectedPhoneCode(selectedCode, phoneCode)
        });
      } else if (phoneCode.conPhoneCode !== '+1') {
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode,
          selected: getselectedPhoneCode(selectedCode, phoneCode)
        });
      }
    });

    return response.join("");
  }

  function getselectedPhoneCode(selectedCode, phoneCode) {
    if (selectedCode == phoneCode.conPhoneCode) {
      return "selected";
    }
    else {
      return "";
    }
  }

  function isDuplicateCadLocationName(e) {
    //Get the corresponding form element, fetch the obj-id and compare 
    //if the object at this facility array is same as the value entered 
    const currentForm = $(this).closest('form');
    const currentIndex = currentForm.data("obj-id");
    const currentCadLocationName = $(this).closest('input').val();
    let isDuplicateCheckRequired = true;
    //If Index is undefined its the master form do the check, else value did not change 
    if (_.isUndefined(currentIndex)) {
      isDuplicateCheckRequired = true;
    } else if (currentCadLocationName === facilityArray[currentIndex].cadLocationName) {
      isDuplicateCheckRequired = false;
    }
    if (isDuplicateCheckRequired) {
      const searchFacilitiesOnPage = _(facilityArray).findWhere({ cadLocationName: currentCadLocationName });
      //Not Found on the Page, Check on Server if the facility name exists 
      if (_.isUndefined(searchFacilitiesOnPage)) {
        $.ajax({
          async: false,
          data: {
            cadLocationName: currentCadLocationName
          },
          url: validateCadLocationNameUrl,
          dataType: "JSON",
          type: 'POST',
          success: function (data) {
            if (data.response == true) {
              currentForm.find('.dup-facName').show();
            } else {
              currentForm.find('.dup-facName').hide();
            }
          }
        });
      } else {
        currentForm.find('.dup-facName').show();
      }
    } else {
      currentForm.find('.dup-facName').hide();
    }
  }

  function isDuplicateCadAddressId(e) {
    const currentForm = $(this).closest('form');
    const currentIndex = currentForm.data("obj-id");
    const currentAddressId = $(this).closest('input').val();
    let isDuplicateCheckRequired = true;
    //If Index is undefined its the master form do the check, else value did not change 
    if (_.isUndefined(currentIndex)) {
      isDuplicateCheckRequired = true;
    } else if (currentAddressId === facilityArray[currentIndex].cadAddressId) {
      isDuplicateCheckRequired = false;
    }
    if (isDuplicateCheckRequired && !(_.isEmpty(currentAddressId))) {
      const searchAddressIdOnPage = _(facilityArray).findWhere({ cadAddressId: currentAddressId });
      //Not Found on the Page, Check on Server if the facility name exists 
      if (_.isUndefined(searchAddressIdOnPage)) {
        $.ajax({
          async: false,
          data: {
            cadAddressId: currentAddressId
          },
          url: validateCadAddressIdUrl,
          dataType: "JSON",
          type: 'POST',
          success: function (data) {
            if (data.response == true) {
              currentForm.find('.dup-facId').show();
            } else {
              currentForm.find('.dup-facId').hide();
            }
          }
        });
      } else {
        currentForm.find('.dup-facId').show();
      }
    } else {
      currentForm.find('.dup-facId').hide();
    }
  }

  function setCarrierOrgsForEdit(organizations, affiliatedCarrierOrg, cmrCarrier) {
    const searchCarrierByScacHtml = $(render(searchCarrierByScacWrapperTemplate, {

      carName: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.orgName) ? "" : organizations.orgName,
      carScac: isNullOrUndefined(cmrCarrier) ? "" : isNullOrUndefined(cmrCarrier.carScac) ? "" : cmrCarrier.carScac,
      carGln: isNullOrUndefined(cmrCarrier) ? "" : isNullOrUndefined(cmrCarrier.carGln) ? "" : cmrCarrier.carGln,
      carContactName: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(cmrCarrier.carContactName) ? "" : cmrCarrier.carContactName,
      carPhoneCountryCode: isNullOrUndefined(cmrCarrier) ? "" : isNullOrUndefined(cmrCarrier.carPhoneCountryCode) ? "" : cmrCarrier.carPhoneCountryCode,
      carContactPhone: isNullOrUndefined(cmrCarrier) ? "" : isNullOrUndefined(cmrCarrier.carContactPhone) ? "" : cmrCarrier.carContactPhone,
      cadContactEmail: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadContactEmail) ? "" : organizations.cmrAddress[0].cadContactEmail,
      cadCountry: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadCountry) ? "" : organizations.cmrAddress[0].cadCountry,
      cadAddress1: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadAddress1) ? "" : organizations.cmrAddress[0].cadAddress1,
      cadAddress2: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadAddress2) ? "" : organizations.cmrAddress[0].cadAddress2,
      cadCity: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadCity) ? "" : organizations.cmrAddress[0].cadCity,
      cadState: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadState) ? "" : organizations.cmrAddress[0].cadState,
      cadZipcode: isNullOrUndefined(organizations) ? "" : isNullOrUndefined(organizations.cmrAddress[0]) ? "" : isNullOrUndefined(organizations.cmrAddress[0].cadZipcode) ? "" : organizations.cmrAddress[0].cadZipcode,
      countries: getRenderedCountriesforCarr(countries),
      phoneCodes: getRenderedPhoneCodes(phoneCodes)

    }));
    instantiateSelect2(searchCarrierByScacHtml.find('.select2-select'));
    let phoneCodeIdSelected = "";
    if (cmrCarrier != null) {
      phoneCodeIdSelected = cmrCarrier.carPhoneCountryCode;
    }

    let stateCodeIdSelected = "";
    if (organizations != null && organizations.cmrAddress[0] != null && organizations.cmrAddress[0].cadState != null) {
      stateCodeIdSelected = organizations.cmrAddress[0].cadState;
    }
    let countryCodeIdSelected = "";
    if (organizations != null && organizations.cmrAddress[0] != null && organizations.cmrAddress[0].cadCountry != null) {
      countryCodeIdSelected = organizations.cmrAddress[0].cadCountry;
    }

    let countryCodeValue = '';
      $(countries).each(function() {
        if(this.conId.toString() === countryCodeIdSelected) {
          countryCodeValue=this.conCode.toString();
        }
      });
    if(countryCodeValue!=''){  
        searchCarrierByScacHtml.find(".carrier-by-scac-country").val(countryCodeValue).prop('selected', true);
    }
    searchCarrierByScacHtml.find('.carrier-by-scac-state').val(stateCodeIdSelected).trigger('change');
    searchCarrierByScacHtml.find(".carrier-phone-code").val(phoneCodeIdSelected).trigger('change');
    searchCarrierByScacHtml.find(".carrier-by-scac-country").on("change", handleCarCountryChange);
    let carrierPhone=$('.carrier-phone-number');
    
    if (phoneCodeIdSelected === "+1") {
      carrierPhone.addClass("phoneUS");
      carrierPhone.removeClass("phoneNonUS");
      carrierPhone.attr("placeholder", "___-____");
      carrierPhone.addClass("phone-format");
      carrierPhone.inputmask("(999) 999-9999");
    } else {
      carrierPhone.addClass("phoneNonUS");
      carrierPhone.removeClass("phoneUS");
      carrierPhone.removeClass("phone-format");
      carrierPhone.removeAttr('placeholder'); 
      carrierPhone.inputmask("");

      let val= carrierPhone.val();						
      if(val){
        const v=val.replace(/[^0-9.]/g, "");
        carrierPhone.val(v);
      }
    }


    

    $('.carrierFormEdit').append(searchCarrierByScacHtml);
    
 
    searchCarrierByScacHtml.find('.carrier-by-scac-country').trigger('change');
    searchCarrierByScacHtml.find("#carrier-section-div :input").prop("disabled", true);
    searchCarrierByScacHtml.find('.phoneUS').inputmask({ mask: "(999) 999-9999" });
    newCarrierTeamMemberDetailsHandler();

  }

  function getCmrCarrierDetails(organizations, affiliatedCarrierOrgs) {
    var i;
    for (i = 0; i < affiliatedCarrierOrgs.length; i++) {

      if (affiliatedCarrierOrgs[i].orgId === organizations.orgId) {
        return affiliatedCarrierOrgs[i];
      }
    }

  }

  function addTeamMemberForEditCarrierDetails(teammember) {
    let arrayIndex = "";
    if (_.isUndefined(teamMemberObj.editIndexId)) {
      // new flow
      arrayIndex = teamMemberArray.length;
      const carrierTeamMemberDetails = setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex);
      teamMemberArray.push(teamMemberObj);
      if (elsPage.orgType.val() == 'Transportation Broker') {
        $('#access-to-team-members-broker').append(carrierTeamMemberDetails);
      } else {
        $('#access-to-team-members-carrier').append(carrierTeamMemberDetails);
      }

    } else {
      // edit flow
      arrayIndex = teamMemberObj.editIndexId;
      const carrierTeamMemberDetails = setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex);
      $('#team-member-edit-' + arrayIndex).html(carrierTeamMemberDetails);
      teamMemberObj = {};
    }
  }

  function setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex) {
    teamMemberObj.userName = teammember.userName;
    teamMemberObj.firstName = teammember.firstName;
    teamMemberObj.lastName = teammember.lastName;
    teamMemberObj.status = teammember.status == 0 ? "Active" : "Inactive";
    teamMemberObj.title = $("#org-title-" + arrayIndex).val();
    teamMemberObj.email = teammember.emailAddress;
    teamMemberObj.phoneCode = teammember.phoneCode;
    teamMemberObj.phone = formatPhone(teammember.phoneNumber);
    teamMemberObj.activateUser = teammember.status == 0 ? "q-display-none" : "";
    teamMemberObj.inactivateUser = teammember.status == 0 ? "" : "q-display-none";


    const carrierTeamMemberDetails = $(render(require("./html/orgDetails/teamMemberDetails.html"), {
      username: teamMemberObj.userName,
      title: teamMemberObj.title,
      email: teamMemberObj.email,
      phoneCode: teamMemberObj.phoneCode,
      phone: teamMemberObj.phone,
      firstname: teamMemberObj.firstName,
      lastname: teamMemberObj.lastName,
      status: teamMemberObj.status,
      activateUser: teamMemberObj.activateUser,
      inactivateUser: teamMemberObj.inactivateUser,
      userid: teammember.userId,
      arrayIndex
    }));
    return carrierTeamMemberDetails;
  }

  //duplicate address check
  function validateDuplicateAddress() {
    let isValid = true;
    let carrierContactAddress1 = "";
    let carrierContactAddress2 = "";
    let carrierContactCity = "";
    let carrierContactState = "";
    carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
    carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
    carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
    carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();

    if (carrierContactAddress1 != null && carrierContactCity != null && carrierContactState != null) {
      $.ajax({
        async: false,
        data: {
          carrierContactAddress1: carrierContactAddress1,
          carrierContactAddress2: carrierContactAddress2,
          carrierContactCity: carrierContactCity,
          carrierContactState: carrierContactState
        },
        url: checkDuplicateAddressUrl,
        dataType: 'JSON',
        type: 'POST',
        success: function (response) {
          if (response == true) {
            isAddressDuplicate = true;
            $(".dup-address").css("display", "");
            isValid = false;
          } else {
            isAddressDuplicate = false;
          }
        }
      });
    }
    if (isValid)
      $(".dup-address").css("display", "none");
    else
      $(".dup-address").css("display", "");
    return isValid;
  }

  function editCarrierAndTeamMember() {
    if (editForm && organizations.orgType == "Carrier") {
      $('.master-form-section').hide();
      elsPage.addFacilitySection.hide();
      elsPage.nextAddfacilityBtn.hide();
      elsPage.selectOrgPopupBtn.hide();
      elsPage.facilityNwSection.hide();
      elsPage.carrierSection.hide();
      let affiliatedCarrierOrg = getCmrCarrierDetails(organizations, affiliatedCarrierOrgs);
      setCarrierOrgsForEdit(organizations, affiliatedCarrierOrg, cmrCarrier);
      if ($.isEmptyObject(teamMemberDetailsForEdit)) {
        var i;
        for (i = 0; i < teamMemberDetailsForEdit.length; i++) {

          addTeamMemberForEditCarrierDetails(teamMemberDetailsForEdit[0]);
        }
      }
      setTeamMembersForEdit("carrier");
      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
    }
  }
  init();
}


// WEBPACK FOOTER //
// ./src/pages/addressBook/addOrgFacilityForm.js